export const exportedDashboard ={
    "filter": {
        "dateRange": {
            "start": "2021-11-28",
            "end": "2022-11-28",
            "zoneId": "Indian/Reunion"
        }
    },
    "dashboard": {
        "id": "manager",
        "data": {
            "vizResponses": {
                "mainSatScore": {
                    "value": 37,
                    "count": 4624,
                    "trend": -6,
                    "from": "2021-11-27T20:00:00.000Z",
                    "to": "2022-11-27T20:00:00.000Z",
                    "distribution": {
                        "NEGATIVE": 4355,
                        "POSITIVE": 109,
                        "NEUTRAL": 160
                    },
                    "comparison": null
                },
                "refSatScore": {
                    "value": 62,
                    "count": 1544,
                    "trend": -14,
                    "from": "2021-11-27T20:00:00.000Z",
                    "to": "2022-11-27T20:00:00.000Z",
                    "distribution": {
                        "NEGATIVE": 1527,
                        "POSITIVE": 15,
                        "NEUTRAL": 2
                    },
                    "comparison": null
                },
                "positiveTopicImpact": [
                    {
                        "topic": "Amabilité",
                        "impact": 23,
                        "trend": 2,
                        "count": 2868
                    },
                    {
                        "topic": "Compétence",
                        "impact": 32,
                        "trend": 9,
                        "count": 4385
                    },
                    {
                        "topic": "Livraison",
                        "impact": 22,
                        "trend": 3,
                        "count": 1550
                    },
                    {
                        "topic": "Qualité",
                        "impact": 41,
                        "trend": -6,
                        "count": 2205
                    },
                    {
                        "topic": "Ergonomie",
                        "impact": 44,
                        "trend": -9,
                        "count": 4198
                    }
                ],
                "negativeTopicImpact": [
                    {
                        "topic": "Amabilité",
                        "impact": -46,
                        "trend": -9,
                        "count": 4168
                    },
                    {
                        "topic": "Compétence",
                        "impact": -4,
                        "trend": -5,
                        "count": 1228
                    },
                    {
                        "topic": "Livraison",
                        "impact": -38,
                        "trend": -4,
                        "count": 1155
                    },
                    {
                        "topic": "Qualité",
                        "impact": -45,
                        "trend": 9,
                        "count": 453
                    },
                    {
                        "topic": "Ergonomie",
                        "impact": -31,
                        "trend": 2,
                        "count": 148
                    }
                ],
                "satEvolution": {
                    "series": [
                        "main",
                        "ref"
                    ],
                    "values": [
                        {
                            "date": "2019-01-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": 21
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 4
                                }
                            }
                        },
                        {
                            "date": "2019-02-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -70
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 49
                                }
                            }
                        },
                        {
                            "date": "2019-03-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -6
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": -67
                                }
                            }
                        },
                        {
                            "date": "2019-04-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -85
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": -76
                                }
                            }
                        },
                        {
                            "date": "2019-05-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -43
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 51
                                }
                            }
                        },
                        {
                            "date": "2019-06-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -62
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 4
                                }
                            }
                        },
                        {
                            "date": "2019-07-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -30
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": -16
                                }
                            }
                        },
                        {
                            "date": "2019-08-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": 19
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 56
                                }
                            }
                        },
                        {
                            "date": "2019-09-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -58
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 46
                                }
                            }
                        },
                        {
                            "date": "2019-10-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": 0
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 0
                                }
                            }
                        },
                        {
                            "date": "2019-11-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -85
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 33
                                }
                            }
                        },
                        {
                            "date": "2019-12-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": 3
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": 84
                                }
                            }
                        },
                        {
                            "date": "2020-01-01",
                            "values": {
                                "main": {
                                    "@type": "double",
                                    "value": -35
                                },
                                "ref": {
                                    "@type": "double",
                                    "value": -96
                                }
                            }
                        }
                    ]
                },
                "positiveTopicImpactTopEvolution": [
                    {
                        "topic": "Livraison",
                        "value": 14.2,
                        "trend": 2.4,
                        "feedback": {
                            "verbatims": [
                                {
                                    "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                                    "offsets": [
                                        {
                                            "tree": "topic",
                                            "start": 114,
                                            "end": 150,
                                            "tonality": "POSITIVE",
                                            "category": "instore/topicGenericStore"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 129,
                                            "end": 150,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 0,
                                            "end": 15,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        }
                                    ],
                                    "sentences": [
                                        {
                                            "ordinal": 1,
                                            "start": 0,
                                            "end": 95
                                        },
                                        {
                                            "ordinal": 2,
                                            "start": 95,
                                            "end": 154
                                        },
                                        {
                                            "ordinal": 3,
                                            "start": 154,
                                            "end": 179
                                        }
                                    ]
                                }
                            ],
                            "enhancement": {
                                "satisfaction": "NEGATIVE",
                                "categories": {
                                    "topic": [
                                        "instore/topicGenericStore"
                                    ],
                                    "satisfaction": [
                                        "satisfaction/topicSatisfaction"
                                    ]
                                }
                            },
                            "metadata": {
                                "standard": {
                                    "channelKind": "survey",
                                    "channelName": "critizer",
                                    "locale": "fr_FR"
                                },
                                "custom": {
                                    "place_name": "Paris",
                                    "place_levels_Regroupement_Bu": "Ile de France",
                                    "place_levels_Enseigne": "BHV",
                                    "context_extra_fid": "XxpBWmsViB"
                                }
                            },
                            "date": 1669619675945,
                            "satMood": "POSITIVE",
                            "satScore": 3,
                            "satType": "NPS",
                            "id": 0
                        }
                    },
                    {
                        "topic": "Qualité",
                        "value": -8,
                        "trend": 3.8,
                        "feedback": {
                            "verbatims": [
                                {
                                    "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                    "offsets": [
                                        {
                                            "tree": "topic",
                                            "start": 216,
                                            "end": 236,
                                            "tonality": "POSITIVE",
                                            "category": "brandandproduct/topicQualityOfService"
                                        },
                                        {
                                            "tree": "topic",
                                            "start": 640,
                                            "end": 676,
                                            "tonality": "POSITIVE",
                                            "category": "staff/topicAttentiveness"
                                        },
                                        {
                                            "tree": "topic",
                                            "start": 160,
                                            "end": 175,
                                            "tonality": "NEUTRAL",
                                            "category": "staff/topicAmability"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 247,
                                            "end": 264,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 0,
                                            "end": 7,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        }
                                    ],
                                    "sentences": [
                                        {
                                            "ordinal": 1,
                                            "start": 0,
                                            "end": 89
                                        },
                                        {
                                            "ordinal": 2,
                                            "start": 89,
                                            "end": 124
                                        },
                                        {
                                            "ordinal": 3,
                                            "start": 124,
                                            "end": 189
                                        },
                                        {
                                            "ordinal": 4,
                                            "start": 189,
                                            "end": 239
                                        },
                                        {
                                            "ordinal": 5,
                                            "start": 189,
                                            "end": 239
                                        },
                                        {
                                            "ordinal": 6,
                                            "start": 239,
                                            "end": 325
                                        },
                                        {
                                            "ordinal": 7,
                                            "start": 325,
                                            "end": 429
                                        },
                                        {
                                            "ordinal": 8,
                                            "start": 429,
                                            "end": 502
                                        },
                                        {
                                            "ordinal": 9,
                                            "start": 502,
                                            "end": 562
                                        },
                                        {
                                            "ordinal": 10,
                                            "start": 562,
                                            "end": 641
                                        },
                                        {
                                            "ordinal": 11,
                                            "start": 641,
                                            "end": 719
                                        },
                                        {
                                            "ordinal": 12,
                                            "start": 719,
                                            "end": 742
                                        },
                                        {
                                            "ordinal": 13,
                                            "start": 742,
                                            "end": 842
                                        },
                                        {
                                            "ordinal": 14,
                                            "start": 842,
                                            "end": 885
                                        },
                                        {
                                            "ordinal": 15,
                                            "start": 885,
                                            "end": 904
                                        },
                                        {
                                            "ordinal": 16,
                                            "start": 904,
                                            "end": 926
                                        }
                                    ]
                                }
                            ],
                            "enhancement": {
                                "satisfaction": "MIXED",
                                "categories": {
                                    "topic": [
                                        "brandandproduct/topicQualityOfService",
                                        "staff/topicAttentiveness",
                                        "staff/topicAmability"
                                    ],
                                    "emotion": [
                                        "satisfaction/topicSatisfaction"
                                    ]
                                }
                            },
                            "metadata": {
                                "standard": {
                                    "channelKind": "survey",
                                    "channelName": "critizer",
                                    "locale": "fr_FR"
                                },
                                "custom": {
                                    "place_name": "Paris",
                                    "place_levels_Regroupement_Bu": "Ile de France",
                                    "place_levels_Enseigne": "BHV",
                                    "context_extra_fid": "M6cM8BOR4D"
                                }
                            },
                            "date": 1669619675947,
                            "satMood": "POSITIVE",
                            "satScore": 6,
                            "satType": "NPS",
                            "id": 0
                        }
                    },
                    {
                        "topic": "Ergonomie",
                        "value": -3.1,
                        "trend": 1.3,
                        "feedback": {
                            "verbatims": [
                                {
                                    "content": "Bonjour à tous, est ce que c'est possible de recevoir des echantillons pour tester",
                                    "offsets": [
                                        {
                                            "tree": "topic",
                                            "start": 16,
                                            "end": 70,
                                            "tonality": "NEUTRAL",
                                            "category": "offer/topicSample"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 0,
                                            "end": 7,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 58,
                                            "end": 70,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        }
                                    ],
                                    "sentences": [
                                        {
                                            "ordinal": 1,
                                            "start": 0,
                                            "end": 82
                                        }
                                    ]
                                }
                            ],
                            "enhancement": {
                                "satisfaction": "NEUTRAL",
                                "categories": {
                                    "topic": [
                                        "offer/topicSample"
                                    ],
                                    "satisfaction": [
                                        "satisfaction/topicSatisfaction"
                                    ]
                                }
                            },
                            "metadata": {
                                "standard": {
                                    "channelKind": "survey",
                                    "channelName": "critizer",
                                    "locale": "fr_FR"
                                },
                                "custom": {
                                    "place_name": "Paris",
                                    "place_levels_Regroupement_Bu": "Ile de France",
                                    "place_levels_Enseigne": "BHV",
                                    "context_extra_fid": "AY9XKxEcDq"
                                }
                            },
                            "date": 1669619675948,
                            "satMood": "POSITIVE",
                            "satScore": 10,
                            "satType": "NPS",
                            "id": 0
                        }
                    }
                ],
                "negativeTopicImpactTopEvolution": [
                    {
                        "topic": "Amabilité",
                        "value": -13.3,
                        "trend": -6.5,
                        "feedback": {
                            "verbatims": [
                                {
                                    "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                    "offsets": [
                                        {
                                            "tree": "topic",
                                            "start": 216,
                                            "end": 236,
                                            "tonality": "POSITIVE",
                                            "category": "brandandproduct/topicQualityOfService"
                                        },
                                        {
                                            "tree": "topic",
                                            "start": 640,
                                            "end": 676,
                                            "tonality": "POSITIVE",
                                            "category": "staff/topicAttentiveness"
                                        },
                                        {
                                            "tree": "topic",
                                            "start": 160,
                                            "end": 175,
                                            "tonality": "NEUTRAL",
                                            "category": "staff/topicAmability"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 247,
                                            "end": 264,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 0,
                                            "end": 7,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        }
                                    ],
                                    "sentences": [
                                        {
                                            "ordinal": 1,
                                            "start": 0,
                                            "end": 89
                                        },
                                        {
                                            "ordinal": 2,
                                            "start": 89,
                                            "end": 124
                                        },
                                        {
                                            "ordinal": 3,
                                            "start": 124,
                                            "end": 189
                                        },
                                        {
                                            "ordinal": 4,
                                            "start": 189,
                                            "end": 239
                                        },
                                        {
                                            "ordinal": 5,
                                            "start": 189,
                                            "end": 239
                                        },
                                        {
                                            "ordinal": 6,
                                            "start": 239,
                                            "end": 325
                                        },
                                        {
                                            "ordinal": 7,
                                            "start": 325,
                                            "end": 429
                                        },
                                        {
                                            "ordinal": 8,
                                            "start": 429,
                                            "end": 502
                                        },
                                        {
                                            "ordinal": 9,
                                            "start": 502,
                                            "end": 562
                                        },
                                        {
                                            "ordinal": 10,
                                            "start": 562,
                                            "end": 641
                                        },
                                        {
                                            "ordinal": 11,
                                            "start": 641,
                                            "end": 719
                                        },
                                        {
                                            "ordinal": 12,
                                            "start": 719,
                                            "end": 742
                                        },
                                        {
                                            "ordinal": 13,
                                            "start": 742,
                                            "end": 842
                                        },
                                        {
                                            "ordinal": 14,
                                            "start": 842,
                                            "end": 885
                                        },
                                        {
                                            "ordinal": 15,
                                            "start": 885,
                                            "end": 904
                                        },
                                        {
                                            "ordinal": 16,
                                            "start": 904,
                                            "end": 926
                                        }
                                    ]
                                }
                            ],
                            "enhancement": {
                                "satisfaction": "MIXED",
                                "categories": {
                                    "topic": [
                                        "brandandproduct/topicQualityOfService",
                                        "staff/topicAttentiveness",
                                        "staff/topicAmability"
                                    ],
                                    "emotion": [
                                        "satisfaction/topicSatisfaction"
                                    ]
                                }
                            },
                            "metadata": {
                                "standard": {
                                    "channelKind": "survey",
                                    "channelName": "critizer",
                                    "locale": "fr_FR"
                                },
                                "custom": {
                                    "place_name": "Paris",
                                    "place_levels_Regroupement_Bu": "Ile de France",
                                    "place_levels_Enseigne": "BHV",
                                    "context_extra_fid": "3FcEVsTwew"
                                }
                            },
                            "date": 1669619675949,
                            "satMood": "NEGATIVE",
                            "satScore": 8,
                            "satType": "NPS",
                            "id": 0
                        }
                    },
                    {
                        "topic": "Compétence",
                        "value": -3.2,
                        "trend": -6.8,
                        "feedback": {
                            "verbatims": [
                                {
                                    "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                                    "offsets": [
                                        {
                                            "tree": "topic",
                                            "start": 114,
                                            "end": 150,
                                            "tonality": "POSITIVE",
                                            "category": "instore/topicGenericStore"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 129,
                                            "end": 150,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 0,
                                            "end": 15,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        }
                                    ],
                                    "sentences": [
                                        {
                                            "ordinal": 1,
                                            "start": 0,
                                            "end": 95
                                        },
                                        {
                                            "ordinal": 2,
                                            "start": 95,
                                            "end": 154
                                        },
                                        {
                                            "ordinal": 3,
                                            "start": 154,
                                            "end": 179
                                        }
                                    ]
                                }
                            ],
                            "enhancement": {
                                "satisfaction": "NEGATIVE",
                                "categories": {
                                    "topic": [
                                        "instore/topicGenericStore"
                                    ],
                                    "satisfaction": [
                                        "satisfaction/topicSatisfaction"
                                    ]
                                }
                            },
                            "metadata": {
                                "standard": {
                                    "channelKind": "survey",
                                    "channelName": "critizer",
                                    "locale": "fr_FR"
                                },
                                "custom": {
                                    "place_name": "Paris",
                                    "place_levels_Regroupement_Bu": "Ile de France",
                                    "place_levels_Enseigne": "BHV",
                                    "context_extra_fid": "DwJLqLpbhT"
                                }
                            },
                            "date": 1669619675951,
                            "satMood": "NEGATIVE",
                            "satScore": 4,
                            "satType": "NPS",
                            "id": 0
                        }
                    },
                    {
                        "topic": "Livraison",
                        "value": -4.7,
                        "trend": -3.5,
                        "feedback": {
                            "verbatims": [
                                {
                                    "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                    "offsets": [
                                        {
                                            "tree": "topic",
                                            "start": 216,
                                            "end": 236,
                                            "tonality": "POSITIVE",
                                            "category": "brandandproduct/topicQualityOfService"
                                        },
                                        {
                                            "tree": "topic",
                                            "start": 640,
                                            "end": 676,
                                            "tonality": "POSITIVE",
                                            "category": "staff/topicAttentiveness"
                                        },
                                        {
                                            "tree": "topic",
                                            "start": 160,
                                            "end": 175,
                                            "tonality": "NEUTRAL",
                                            "category": "staff/topicAmability"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 247,
                                            "end": 264,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        },
                                        {
                                            "tree": "emotion",
                                            "start": 0,
                                            "end": 7,
                                            "tonality": "POSITIVE",
                                            "category": "satisfaction/topicSatisfaction"
                                        }
                                    ],
                                    "sentences": [
                                        {
                                            "ordinal": 1,
                                            "start": 0,
                                            "end": 89
                                        },
                                        {
                                            "ordinal": 2,
                                            "start": 89,
                                            "end": 124
                                        },
                                        {
                                            "ordinal": 3,
                                            "start": 124,
                                            "end": 189
                                        },
                                        {
                                            "ordinal": 4,
                                            "start": 189,
                                            "end": 239
                                        },
                                        {
                                            "ordinal": 5,
                                            "start": 189,
                                            "end": 239
                                        },
                                        {
                                            "ordinal": 6,
                                            "start": 239,
                                            "end": 325
                                        },
                                        {
                                            "ordinal": 7,
                                            "start": 325,
                                            "end": 429
                                        },
                                        {
                                            "ordinal": 8,
                                            "start": 429,
                                            "end": 502
                                        },
                                        {
                                            "ordinal": 9,
                                            "start": 502,
                                            "end": 562
                                        },
                                        {
                                            "ordinal": 10,
                                            "start": 562,
                                            "end": 641
                                        },
                                        {
                                            "ordinal": 11,
                                            "start": 641,
                                            "end": 719
                                        },
                                        {
                                            "ordinal": 12,
                                            "start": 719,
                                            "end": 742
                                        },
                                        {
                                            "ordinal": 13,
                                            "start": 742,
                                            "end": 842
                                        },
                                        {
                                            "ordinal": 14,
                                            "start": 842,
                                            "end": 885
                                        },
                                        {
                                            "ordinal": 15,
                                            "start": 885,
                                            "end": 904
                                        },
                                        {
                                            "ordinal": 16,
                                            "start": 904,
                                            "end": 926
                                        }
                                    ]
                                }
                            ],
                            "enhancement": {
                                "satisfaction": "MIXED",
                                "categories": {
                                    "topic": [
                                        "brandandproduct/topicQualityOfService",
                                        "staff/topicAttentiveness",
                                        "staff/topicAmability"
                                    ],
                                    "emotion": [
                                        "satisfaction/topicSatisfaction"
                                    ]
                                }
                            },
                            "metadata": {
                                "standard": {
                                    "channelKind": "survey",
                                    "channelName": "critizer",
                                    "locale": "fr_FR"
                                },
                                "custom": {
                                    "place_name": "Paris",
                                    "place_levels_Regroupement_Bu": "Ile de France",
                                    "place_levels_Enseigne": "BHV",
                                    "context_extra_fid": "gFIasPiwgV"
                                }
                            },
                            "date": 1669619675951,
                            "satMood": "NEGATIVE",
                            "satScore": 4,
                            "satType": "NPS",
                            "id": 0
                        }
                    }
                ],
                "actionList": [],
                "customersToRecall": {
                    "enhancement.categories.risk/churn": {
                        "value": 53,
                        "feedbacks": [
                            {
                                "id": 0,
                                "date": 1669619675953,
                                "verbatims": [
                                    {
                                        "content": "bonjour",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 7
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Comment puis-je vous aider?",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "category": "instore/topicGenericStore",
                                                "start": 86,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                                "start": 14,
                                                "end": 17,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/circonstantSoon",
                                                "start": 94,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "patternsandtools-fr-FR/Speaker",
                                                "start": 123,
                                                "end": 125,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                                "start": 86,
                                                "end": 93,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "packaging-fr-FR/argumentPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "productfeatures-fr-FR/dialogActWhere",
                                                "start": 108,
                                                "end": 110,
                                                "tonality": "NEUTRAL"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 152
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "k c est super ...merci pour l info    bonne fin de journée",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "tag",
                                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                                "start": 28,
                                                "end": 43,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                                "start": 17,
                                                "end": 34,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                                "start": 2,
                                                "end": 15,
                                                "tonality": "POSITIVE"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 17
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 17,
                                                "end": 58
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL"
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "chat"
                                    },
                                    "custom": {
                                        "context_extra_fid": "DuAUdfHn9Q"
                                    }
                                },
                                "satMood": "NEUTRAL",
                                "satType": "NPS"
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "4J6vi3VcWD"
                                    }
                                },
                                "date": 1669619675952,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 1
                            },
                            {
                                "id": 2,
                                "date": 1669619675953,
                                "verbatims": [
                                    {
                                        "content": "bonjour",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 7
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Comment puis-je vous aider?",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "category": "instore/topicGenericStore",
                                                "start": 86,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                                "start": 14,
                                                "end": 17,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/circonstantSoon",
                                                "start": 94,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "patternsandtools-fr-FR/Speaker",
                                                "start": 123,
                                                "end": 125,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                                "start": 86,
                                                "end": 93,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "packaging-fr-FR/argumentPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "productfeatures-fr-FR/dialogActWhere",
                                                "start": 108,
                                                "end": 110,
                                                "tonality": "NEUTRAL"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 152
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "k c est super ...merci pour l info    bonne fin de journée",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "tag",
                                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                                "start": 28,
                                                "end": 43,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                                "start": 17,
                                                "end": 34,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                                "start": 2,
                                                "end": 15,
                                                "tonality": "POSITIVE"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 17
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 17,
                                                "end": 58
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL"
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "chat"
                                    },
                                    "custom": {
                                        "context_extra_fid": "DuAUdfHn9Q"
                                    }
                                },
                                "satMood": "NEUTRAL",
                                "satType": "NPS"
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 114,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "instore/topicGenericStore"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 129,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 15,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 95
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 95,
                                                "end": 154
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 154,
                                                "end": 179
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEGATIVE",
                                    "categories": {
                                        "topic": [
                                            "instore/topicGenericStore"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "Eay6tJmt4f"
                                    }
                                },
                                "date": 1669619675953,
                                "satMood": "NEGATIVE",
                                "satType": "NPS",
                                "id": 3
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "4J6vi3VcWD"
                                    }
                                },
                                "date": 1669619675952,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 4
                            }
                        ]
                    },
                    "enhancement.categories.risk/UnkeptCommitment": {
                        "value": 40,
                        "feedbacks": [
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "FW0yQcEGvJ"
                                    }
                                },
                                "date": 1669619675955,
                                "satMood": "POSITIVE",
                                "satType": "NPS",
                                "id": 0
                            },
                            {
                                "id": 1,
                                "date": 1669619675955,
                                "verbatims": [
                                    {
                                        "content": "bonjour",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 7
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Comment puis-je vous aider?",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "category": "instore/topicGenericStore",
                                                "start": 86,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                                "start": 14,
                                                "end": 17,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/circonstantSoon",
                                                "start": 94,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "patternsandtools-fr-FR/Speaker",
                                                "start": 123,
                                                "end": 125,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                                "start": 86,
                                                "end": 93,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "packaging-fr-FR/argumentPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "productfeatures-fr-FR/dialogActWhere",
                                                "start": 108,
                                                "end": 110,
                                                "tonality": "NEUTRAL"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 152
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "k c est super ...merci pour l info    bonne fin de journée",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "tag",
                                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                                "start": 28,
                                                "end": 43,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                                "start": 17,
                                                "end": 34,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                                "start": 2,
                                                "end": 15,
                                                "tonality": "POSITIVE"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 17
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 17,
                                                "end": 58
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL"
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "chat"
                                    },
                                    "custom": {
                                        "context_extra_fid": "NUwWvyLfcw"
                                    }
                                },
                                "satMood": "NEUTRAL",
                                "satType": "NPS"
                            },
                            {
                                "id": 2,
                                "date": 1669619675955,
                                "verbatims": [
                                    {
                                        "content": "bonjour",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 7
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Comment puis-je vous aider?",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "category": "instore/topicGenericStore",
                                                "start": 86,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                                "start": 14,
                                                "end": 17,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/circonstantSoon",
                                                "start": 94,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "patternsandtools-fr-FR/Speaker",
                                                "start": 123,
                                                "end": 125,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                                "start": 86,
                                                "end": 93,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "packaging-fr-FR/argumentPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "productfeatures-fr-FR/dialogActWhere",
                                                "start": 108,
                                                "end": 110,
                                                "tonality": "NEUTRAL"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 152
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "k c est super ...merci pour l info    bonne fin de journée",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "tag",
                                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                                "start": 28,
                                                "end": 43,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                                "start": 17,
                                                "end": 34,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                                "start": 2,
                                                "end": 15,
                                                "tonality": "POSITIVE"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 17
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 17,
                                                "end": 58
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL"
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "chat"
                                    },
                                    "custom": {
                                        "context_extra_fid": "NUwWvyLfcw"
                                    }
                                },
                                "satMood": "NEUTRAL",
                                "satType": "NPS"
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "FW0yQcEGvJ"
                                    }
                                },
                                "date": 1669619675955,
                                "satMood": "POSITIVE",
                                "satType": "NPS",
                                "id": 3
                            },
                            {
                                "id": 4,
                                "date": 1669619675955,
                                "verbatims": [
                                    {
                                        "content": "bonjour",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 7
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Comment puis-je vous aider?",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "category": "instore/topicGenericStore",
                                                "start": 86,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                                "start": 14,
                                                "end": 17,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/circonstantSoon",
                                                "start": 94,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "patternsandtools-fr-FR/Speaker",
                                                "start": 123,
                                                "end": 125,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                                "start": 86,
                                                "end": 93,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "packaging-fr-FR/argumentPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "productfeatures-fr-FR/dialogActWhere",
                                                "start": 108,
                                                "end": 110,
                                                "tonality": "NEUTRAL"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 152
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "k c est super ...merci pour l info    bonne fin de journée",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "tag",
                                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                                "start": 28,
                                                "end": 43,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                                "start": 17,
                                                "end": 34,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                                "start": 2,
                                                "end": 15,
                                                "tonality": "POSITIVE"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 17
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 17,
                                                "end": 58
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL"
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "chat"
                                    },
                                    "custom": {
                                        "context_extra_fid": "NUwWvyLfcw"
                                    }
                                },
                                "satMood": "NEUTRAL",
                                "satType": "NPS"
                            }
                        ]
                    },
                    "enhancement.categories.risk/NotWarned": {
                        "value": 56,
                        "feedbacks": [
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour à tous, est ce que c'est possible de recevoir des echantillons pour tester",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 16,
                                                "end": 70,
                                                "tonality": "NEUTRAL",
                                                "category": "offer/topicSample"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 58,
                                                "end": 70,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 82
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL",
                                    "categories": {
                                        "topic": [
                                            "offer/topicSample"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "2yoRW9mC93"
                                    }
                                },
                                "date": 1669619675957,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 0
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "DnZ5YlSxw3"
                                    }
                                },
                                "date": 1669619675957,
                                "satMood": "NEGATIVE",
                                "satType": "NPS",
                                "id": 1
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 114,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "instore/topicGenericStore"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 129,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 15,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 95
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 95,
                                                "end": 154
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 154,
                                                "end": 179
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEGATIVE",
                                    "categories": {
                                        "topic": [
                                            "instore/topicGenericStore"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "YjrLOaAzRL"
                                    }
                                },
                                "date": 1669619675957,
                                "satMood": "NEGATIVE",
                                "satType": "NPS",
                                "id": 2
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour à tous, est ce que c'est possible de recevoir des echantillons pour tester",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 16,
                                                "end": 70,
                                                "tonality": "NEUTRAL",
                                                "category": "offer/topicSample"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 58,
                                                "end": 70,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 82
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL",
                                    "categories": {
                                        "topic": [
                                            "offer/topicSample"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "2yoRW9mC93"
                                    }
                                },
                                "date": 1669619675957,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 3
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour à tous, est ce que c'est possible de recevoir des echantillons pour tester",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 16,
                                                "end": 70,
                                                "tonality": "NEUTRAL",
                                                "category": "offer/topicSample"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 58,
                                                "end": 70,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 82
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL",
                                    "categories": {
                                        "topic": [
                                            "offer/topicSample"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "2yoRW9mC93"
                                    }
                                },
                                "date": 1669619675957,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 4
                            }
                        ]
                    },
                    "enhancement.categories.risk/callCustomerService": {
                        "value": 27,
                        "feedbacks": [
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "CRR9TEku5E"
                                    }
                                },
                                "date": 1669619675959,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 0
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 114,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "instore/topicGenericStore"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 129,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 15,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 95
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 95,
                                                "end": 154
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 154,
                                                "end": 179
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEGATIVE",
                                    "categories": {
                                        "topic": [
                                            "instore/topicGenericStore"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "3CtrBeyiSh"
                                    }
                                },
                                "date": 1669619675959,
                                "satMood": "NEGATIVE",
                                "satType": "NPS",
                                "id": 1
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 216,
                                                "end": 236,
                                                "tonality": "POSITIVE",
                                                "category": "brandandproduct/topicQualityOfService"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 640,
                                                "end": 676,
                                                "tonality": "POSITIVE",
                                                "category": "staff/topicAttentiveness"
                                            },
                                            {
                                                "tree": "topic",
                                                "start": 160,
                                                "end": 175,
                                                "tonality": "NEUTRAL",
                                                "category": "staff/topicAmability"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 247,
                                                "end": 264,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 7,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 89
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 89,
                                                "end": 124
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 124,
                                                "end": 189
                                            },
                                            {
                                                "ordinal": 4,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 5,
                                                "start": 189,
                                                "end": 239
                                            },
                                            {
                                                "ordinal": 6,
                                                "start": 239,
                                                "end": 325
                                            },
                                            {
                                                "ordinal": 7,
                                                "start": 325,
                                                "end": 429
                                            },
                                            {
                                                "ordinal": 8,
                                                "start": 429,
                                                "end": 502
                                            },
                                            {
                                                "ordinal": 9,
                                                "start": 502,
                                                "end": 562
                                            },
                                            {
                                                "ordinal": 10,
                                                "start": 562,
                                                "end": 641
                                            },
                                            {
                                                "ordinal": 11,
                                                "start": 641,
                                                "end": 719
                                            },
                                            {
                                                "ordinal": 12,
                                                "start": 719,
                                                "end": 742
                                            },
                                            {
                                                "ordinal": 13,
                                                "start": 742,
                                                "end": 842
                                            },
                                            {
                                                "ordinal": 14,
                                                "start": 842,
                                                "end": 885
                                            },
                                            {
                                                "ordinal": 15,
                                                "start": 885,
                                                "end": 904
                                            },
                                            {
                                                "ordinal": 16,
                                                "start": 904,
                                                "end": 926
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "MIXED",
                                    "categories": {
                                        "topic": [
                                            "brandandproduct/topicQualityOfService",
                                            "staff/topicAttentiveness",
                                            "staff/topicAmability"
                                        ],
                                        "emotion": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "CRR9TEku5E"
                                    }
                                },
                                "date": 1669619675959,
                                "satMood": "NEUTRAL",
                                "satType": "NPS",
                                "id": 2
                            },
                            {
                                "id": 3,
                                "date": 1669619675959,
                                "verbatims": [
                                    {
                                        "content": "bonjour",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 7
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Comment puis-je vous aider?",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "category": "instore/topicGenericStore",
                                                "start": 86,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                                "start": 14,
                                                "end": 17,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                                "start": 144,
                                                "end": 150,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/argumentProductPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "stock-fr-FR/circonstantSoon",
                                                "start": 94,
                                                "end": 107,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "patternsandtools-fr-FR/Speaker",
                                                "start": 123,
                                                "end": 125,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                                "start": 86,
                                                "end": 93,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "packaging-fr-FR/argumentPackaging",
                                                "start": 52,
                                                "end": 61,
                                                "tonality": "NEUTRAL"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "productfeatures-fr-FR/dialogActWhere",
                                                "start": 108,
                                                "end": 110,
                                                "tonality": "NEUTRAL"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 152
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    },
                                    {
                                        "content": "k c est super ...merci pour l info    bonne fin de journée",
                                        "type": "chat customer",
                                        "sender": "LV1MNEVRIL",
                                        "customer": true,
                                        "offsets": [
                                            {
                                                "tree": "tag",
                                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                                "start": 28,
                                                "end": 43,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                                "start": 17,
                                                "end": 34,
                                                "tonality": "POSITIVE"
                                            },
                                            {
                                                "tree": "tag",
                                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                                "start": 2,
                                                "end": 15,
                                                "tonality": "POSITIVE"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 17
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 17,
                                                "end": 58
                                            }
                                        ]
                                    },
                                    {
                                        "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                                        "type": "chat agent",
                                        "sender": "srivier",
                                        "customer": false
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEUTRAL"
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "chat"
                                    },
                                    "custom": {
                                        "context_extra_fid": "7wwTojGN9L"
                                    }
                                },
                                "satMood": "POSITIVE",
                                "satType": "NPS"
                            },
                            {
                                "verbatims": [
                                    {
                                        "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                                        "offsets": [
                                            {
                                                "tree": "topic",
                                                "start": 114,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "instore/topicGenericStore"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 129,
                                                "end": 150,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            },
                                            {
                                                "tree": "emotion",
                                                "start": 0,
                                                "end": 15,
                                                "tonality": "POSITIVE",
                                                "category": "satisfaction/topicSatisfaction"
                                            }
                                        ],
                                        "sentences": [
                                            {
                                                "ordinal": 1,
                                                "start": 0,
                                                "end": 95
                                            },
                                            {
                                                "ordinal": 2,
                                                "start": 95,
                                                "end": 154
                                            },
                                            {
                                                "ordinal": 3,
                                                "start": 154,
                                                "end": 179
                                            }
                                        ]
                                    }
                                ],
                                "enhancement": {
                                    "satisfaction": "NEGATIVE",
                                    "categories": {
                                        "topic": [
                                            "instore/topicGenericStore"
                                        ],
                                        "satisfaction": [
                                            "satisfaction/topicSatisfaction"
                                        ]
                                    }
                                },
                                "metadata": {
                                    "standard": {
                                        "channelKind": "survey",
                                        "channelName": "critizer",
                                        "locale": "fr_FR"
                                    },
                                    "custom": {
                                        "place_name": "Paris",
                                        "place_levels_Regroupement_Bu": "Ile de France",
                                        "place_levels_Enseigne": "BHV",
                                        "context_extra_fid": "3CtrBeyiSh"
                                    }
                                },
                                "date": 1669619675959,
                                "satMood": "NEGATIVE",
                                "satType": "NPS",
                                "id": 4
                            }
                        ]
                    }
                },
                "mainRanking": {
                    "items": [
                        {
                            "category": "pricingpolicy/topicPricing",
                            "values": {
                                "SAT_SCORE": 65,
                                "VOLUME": 847,
                                "VOLUME_TREND": 59,
                                "PERCENTAGE": 23,
                                "TREND": -4,
                                "POSITIVE_OPINIONS": 38,
                                "NEGATIVE_OPINIONS": 21
                            },
                            "rank": 1,
                            "highlighted": false
                        },
                        {
                            "category": "pricingpolicy/topicShippingCost",
                            "values": {
                                "SAT_SCORE": 52,
                                "VOLUME": 570,
                                "VOLUME_TREND": -93,
                                "PERCENTAGE": 31,
                                "TREND": -4,
                                "POSITIVE_OPINIONS": 21,
                                "NEGATIVE_OPINIONS": 14
                            },
                            "rank": 2,
                            "highlighted": false
                        },
                        {
                            "category": "pricingpolicy/topicShippingCostTest",
                            "values": {
                                "SAT_SCORE": 29,
                                "VOLUME": 196,
                                "VOLUME_TREND": 53,
                                "PERCENTAGE": 2,
                                "TREND": -1,
                                "POSITIVE_OPINIONS": 43,
                                "NEGATIVE_OPINIONS": 47
                            },
                            "rank": 3,
                            "highlighted": false
                        },
                        {
                            "category": "pricingpolicy/topicPricing2",
                            "values": {
                                "SAT_SCORE": 21,
                                "VOLUME": 326,
                                "VOLUME_TREND": 55,
                                "PERCENTAGE": 87,
                                "TREND": 3,
                                "POSITIVE_OPINIONS": 7,
                                "NEGATIVE_OPINIONS": 15
                            },
                            "rank": 4,
                            "highlighted": false
                        },
                        {
                            "category": "pricingpolicy/topicShippingCost2",
                            "values": {
                                "SAT_SCORE": 94,
                                "VOLUME": 88,
                                "VOLUME_TREND": -2,
                                "PERCENTAGE": 26,
                                "TREND": -3,
                                "POSITIVE_OPINIONS": 34,
                                "NEGATIVE_OPINIONS": 24
                            },
                            "rank": 5,
                            "highlighted": false
                        }
                    ],
                    "totalCount": 1000
                },
                "refRanking": {
                    "items": [
                        {
                            "category": "Galeries Lafayette",
                            "values": {
                                "SAT_SCORE": 79,
                                "VOLUME": 221,
                                "VOLUME_TREND": 46,
                                "PERCENTAGE": 36,
                                "TREND": 6,
                                "POSITIVE_OPINIONS": 31,
                                "NEGATIVE_OPINIONS": 44
                            },
                            "rank": 1,
                            "highlighted": true
                        },
                        {
                            "category": "Le BHV",
                            "values": {
                                "SAT_SCORE": 20,
                                "VOLUME": 265,
                                "VOLUME_TREND": 40,
                                "PERCENTAGE": 44,
                                "TREND": 10,
                                "POSITIVE_OPINIONS": 32,
                                "NEGATIVE_OPINIONS": 6
                            },
                            "rank": 2,
                            "highlighted": false
                        },
                        {
                            "category": "Galeries Lafayette l'Outlet",
                            "values": {
                                "SAT_SCORE": 79,
                                "VOLUME": 616,
                                "VOLUME_TREND": -67,
                                "PERCENTAGE": 94,
                                "TREND": 3,
                                "POSITIVE_OPINIONS": 24,
                                "NEGATIVE_OPINIONS": 31
                            },
                            "rank": 3,
                            "highlighted": false
                        },
                        {
                            "category": "Eataly",
                            "values": {
                                "SAT_SCORE": 11,
                                "VOLUME": 810,
                                "VOLUME_TREND": -8,
                                "PERCENTAGE": 95,
                                "TREND": -9,
                                "POSITIVE_OPINIONS": 24,
                                "NEGATIVE_OPINIONS": 44
                            },
                            "rank": 4,
                            "highlighted": false
                        }
                    ],
                    "totalCount": 1000
                }
            },
            "total": 8959
        },
        "resolvedParams": {
            "satType": {
                "@type": "satType",
                "name": "CSAT10"
            },
            "main": {
                "@type": "fieldValue",
                "field": {
                    "@type": "field",
                    "name": "enhancement.categories.topic"
                },
                "value": [
                    "pricingpolicy",
                    "commercialactivity",
                    "loyaltyprogramme",
                    "website",
                    "topicShippingCost"
                ]
            },
            "comparingDateRange": {
                "@type": "dateRange",
                "start": "2020-11-30",
                "end": "2021-11-30",
                "zoneId": "Indian/Reunion"
            },
            "ref": {
                "@type": "fieldValue",
                "field": {
                    "@type": "field",
                    "name": "metadata.custom.place_levels_Enseigne"
                },
                "value": "Galeries Lafayette"
            }
        }
    },
    "dashboardVizEditor": {
        "validatedData": {}
    },
    "uiConfig": {
        "sat": {
            "NPS": {
                "filter": {
                    "@type": "term",
                    "field": "metadata.standard.channelKind",
                    "term": "survey"
                },
                "scoreField": "metadata.custom.recommendationScore"
            },
            "CSAT10": {
                "filter": {
                    "@type": "term",
                    "field": "metadata.standard.channelKind",
                    "term": "survey"
                },
                "scoreField": "metadata.custom.recommendationScore"
            }
        },
        "reports": [
            {
                "id": "manager",
                "labels": {
                    "fr": "Directeur",
                    "en": "Manager"
                },
                "metric": "satType",
                "parameters": [
                    {
                        "@type": "dateRange",
                        "name": "comparingDateRange"
                    },
                    {
                        "@type": "selector",
                        "name": "satType",
                        "title": {
                            "labels": {
                                "fr": "Sat type label",
                                "en": "Sat type label"
                            }
                        },
                        "displayInPDF": true,
                        "values": {
                            "@type": "list",
                            "items": [
                                {
                                    "@type": "satType",
                                    "name": "NPS"
                                },
                                {
                                    "@type": "field",
                                    "name": "enhancement.categories.topic"
                                }
                            ]
                        }
                    },
                    {
                        "@type": "fieldAndValueSelector",
                        "name": "main",
                        "displayInPDF": true,
                        "labels": {
                            "fr": "mon label",
                            "en": "my label"
                        },
                        "allowMultiSelection": true,
                        "fields": {
                            "@type": "list",
                            "items": [
                                {
                                    "@type": "field",
                                    "name": "enhancement.categories.topic"
                                },
                                {
                                    "@type": "field",
                                    "name": "metadata.custom.place_levels_Regroupement_Bu"
                                },
                                {
                                    "@type": "field",
                                    "name": "metadata.custom.place_name"
                                }
                            ]
                        }
                    },
                    {
                        "@type": "fieldAndValueSelector",
                        "name": "ref",
                        "fields": {
                            "@type": "switch",
                            "cases": [
                                {
                                    "condition": {
                                        "@type": "paramMatch",
                                        "param": "main.field",
                                        "value": "enhancement.categories.topic"
                                    },
                                    "returns": {
                                        "@type": "list",
                                        "items": [
                                            {
                                                "@type": "field",
                                                "name": "metadata.custom.place_levels_Enseigne"
                                            }
                                        ]
                                    }
                                },
                                {
                                    "condition": {
                                        "@type": "paramMatch",
                                        "param": "main.field",
                                        "value": "metadata.custom.place_levels_Regroupement_Bu"
                                    },
                                    "returns": {
                                        "@type": "list",
                                        "items": [
                                            {
                                                "@type": "field",
                                                "name": "metadata.custom.place_levels_Regroupement_Bu"
                                            },
                                            {
                                                "@type": "field",
                                                "name": "metadata.custom.place_levels_Enseigne"
                                            }
                                        ]
                                    }
                                },
                                {
                                    "condition": {
                                        "@type": "paramMatch",
                                        "param": "main.field",
                                        "value": "metadata.custom.place_name"
                                    },
                                    "returns": {
                                        "@type": "list",
                                        "items": [
                                            {
                                                "@type": "field",
                                                "name": "metadata.custom.place_levels_Regroupement_Bu"
                                            },
                                            {
                                                "@type": "field",
                                                "name": "metadata.custom.place_levels_Enseigne"
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ],
                "visualizations": [
                    {
                        "id": "mainSatScore",
                        "@type": "SAT_SCORE",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "terms",
                                "field": "${main.field}",
                                "terms": "${main.value}"
                            }
                        },
                        "uiParams": {
                            "distribution": {
                                "enabled": true,
                                "showNeutral": false
                            }
                        },
                        "layout": {
                            "page": 0,
                            "x": 0,
                            "y": 0,
                            "w": 9,
                            "h": 16
                        }
                    },
                    {
                        "id": "refSatScore",
                        "@type": "SAT_SCORE",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "term",
                                "field": "${ref.field}",
                                "term": "${ref.value}"
                            }
                        },
                        "uiParams": {
                            "arcOpacity": 0.35,
                            "valueStyle": {
                                "fontWeight": "normal"
                            }
                        },
                        "layout": {
                            "page": 0,
                            "x": 9,
                            "y": 0,
                            "w": 9,
                            "h": 16
                        }
                    },
                    {
                        "id": "positiveTopicImpact",
                        "@type": "TOPIC_IMPACT",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "terms",
                                "field": "${main.field}",
                                "terms": "${main.value}"
                            },
                            "polarity": "POSITIVE",
                            "count": 5
                        },
                        "layout": {
                            "page": 0,
                            "x": 18,
                            "y": 0,
                            "w": 15,
                            "h": 16
                        }
                    },
                    {
                        "id": "negativeTopicImpact",
                        "@type": "TOPIC_IMPACT",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "terms",
                                "field": "${main.field}",
                                "terms": "${main.value}"
                            },
                            "polarity": "NEGATIVE",
                            "count": 5
                        },
                        "layout": {
                            "page": 0,
                            "x": 33,
                            "y": 0,
                            "w": 15,
                            "h": 16
                        }
                    },
                    {
                        "id": "satEvolution",
                        "@type": "SAT_EVOLUTION",
                        "params": {
                            "satType": "${satType}",
                            "series": [
                                {
                                    "name": "main",
                                    "constraint": {
                                        "@type": "terms",
                                        "field": "${main.field}",
                                        "terms": "${main.value}"
                                    }
                                },
                                {
                                    "name": "ref",
                                    "constraint": {
                                        "@type": "term",
                                        "field": "${ref.field}",
                                        "term": "${ref.value}"
                                    }
                                }
                            ],
                            "interval": "month"
                        },
                        "uiParams": {
                            "series": {
                                "main": {
                                    "color": "#003591"
                                },
                                "ref": {
                                    "color": "#72B5CC"
                                }
                            }
                        },
                        "layout": {
                            "page": 0,
                            "x": 0,
                            "y": 16,
                            "w": 18,
                            "h": 19
                        }
                    },
                    {
                        "id": "positiveTopicImpactTopEvolution",
                        "@type": "TOPIC_IMPACT_TOP_EVOLUTION",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "terms",
                                "field": "${main.field}",
                                "terms": "${main.value}"
                            },
                            "polarity": "POSITIVE",
                            "count": 3
                        },
                        "layout": {
                            "page": 0,
                            "x": 18,
                            "y": 16,
                            "w": 30,
                            "h": 14
                        }
                    },
                    {
                        "id": "negativeTopicImpactTopEvolution",
                        "@type": "TOPIC_IMPACT_TOP_EVOLUTION",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "terms",
                                "field": "${main.field}",
                                "terms": "${main.value}"
                            },
                            "polarity": "NEGATIVE",
                            "count": 3
                        },
                        "layout": {
                            "page": 0,
                            "x": 18,
                            "y": 30,
                            "w": 30,
                            "h": 14
                        }
                    },
                    {
                        "id": "actionList",
                        "@type": "ACTION_LIST",
                        "uiParams": {
                            "theme": {
                                "dark": true
                            }
                        },
                        "layout": {
                            "page": 0,
                            "x": 0,
                            "y": 25,
                            "w": 18,
                            "h": 9
                        }
                    },
                    {
                        "id": "customersToRecall",
                        "@type": "CUSTOMERS_TO_RECALL",
                        "params": {
                            "constraint": {
                                "@type": "terms",
                                "field": "${main.field}",
                                "terms": "${main.value}"
                            },
                            "items": {
                                "enhancement.categories.risk/churn": {
                                    "constraint": {
                                        "@type": "term",
                                        "field": "enhancement.categories.risk",
                                        "term": "churn"
                                    }
                                },
                                "enhancement.categories.risk/UnkeptCommitment": {
                                    "constraint": {
                                        "@type": "term",
                                        "field": "enhancement.categories.risk",
                                        "term": "UnkeptCommitment"
                                    }
                                },
                                "enhancement.categories.risk/NotWarned": {
                                    "constraint": {
                                        "@type": "term",
                                        "field": "enhancement.categories.risk",
                                        "term": "NotWarned"
                                    }
                                },
                                "enhancement.categories.risk/callCustomerService": {
                                    "constraint": {
                                        "@type": "term",
                                        "field": "enhancement.categories.risk",
                                        "term": "callCustomerService"
                                    }
                                }
                            }
                        },
                        "uiParams": {
                            "color": "#DB3167"
                        },
                        "layout": {
                            "page": 1,
                            "x": 0,
                            "y": 0,
                            "w": 18,
                            "h": 30
                        }
                    },
                    {
                        "id": "mainRanking",
                        "@type": "RANKING",
                        "params": {
                            "satType": "${satType}",
                            "constraint": {
                                "@type": "terms",
                                "field": "${ref.field}",
                                "terms": "${ref.value}"
                            },
                            "field": "${main.field}",
                            "highlight": "${main.value}",
                            "count": 5
                        },
                        "layout": {
                            "page": 1,
                            "x": 18,
                            "y": 0,
                            "w": 16,
                            "h": 49
                        }
                    },
                    {
                        "id": "refRanking",
                        "@type": "RANKING",
                        "params": {
                            "satType": "${satType}",
                            "field": "${ref.field}",
                            "highlight": [
                                "${ref.value}"
                            ],
                            "count": 20
                        },
                        "uiParams": {
                            "canSeeMore": true
                        },
                        "layout": {
                            "page": 1,
                            "x": 34,
                            "y": 0,
                            "w": 14,
                            "h": 49
                        }
                    }
                ]
            }
        ]
    },
    "fields": {
        "date": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.standard.channelKind": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Canal",
                "en": "Channel"
            },
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 1
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 1
                },
                "feedbackDetailsView": {
                    "enabled": false,
                    "order": 1
                },
                "topicsStatListView": {
                    "enabled": false,
                    "order": 2
                },
                "feedbacksListView": {
                    "enabled": true,
                    "order": 1
                },
                "dashboardFeedbackList": {
                    "enabled": true,
                    "order": 1
                }
            },
            "values": [
                {
                    "name": "survey",
                    "labels": {
                        "fr": "Avis Client",
                        "en": "Critizr Reviews"
                    },
                    "polarized": false
                },
                {
                    "name": "email",
                    "labels": {
                        "fr": "Emails",
                        "en": "Emails"
                    },
                    "polarized": false
                },
                {
                    "name": "chat",
                    "labels": {
                        "fr": "Chat Communautaire",
                        "en": "Chat"
                    },
                    "polarized": false
                }
            ]
        },
        "metadata.standard.channelName": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Sous Canal",
                "en": "Channel Name"
            },
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 2
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 2
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 2
                }
            }
        },
        "metadata.standard.locale": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Langue",
                "en": "Locale"
            },
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 3
                },
                "feedbackDetailsView": {
                    "enabled": false,
                    "order": 3
                }
            },
            "values": [
                {
                    "name": "en_GB",
                    "labels": {
                        "fr": "Anglais",
                        "en": "English"
                    },
                    "polarized": false
                },
                {
                    "name": "fr_FR",
                    "labels": {
                        "fr": "Français",
                        "en": "French"
                    },
                    "polarized": false
                }
            ]
        },
        "enhancement.categories.topic": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Ce que disent mes clients",
                "en": "Topics"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": true,
            "display": {
                "feedbackFilterView": {
                    "enabled": false,
                    "order": 102
                },
                "dashboardFilterView": {
                    "enabled": false,
                    "order": 102
                },
                "feedbackDetailsView": {
                    "enabled": false,
                    "order": 102
                },
                "topicsStatListView": {
                    "enabled": false,
                    "order": 3
                },
                "feedbacksListView": {
                    "enabled": false,
                    "order": 2
                }
            },
            "values": [
                {
                    "name": "pricingpolicy",
                    "labels": {
                        "fr": "Politique tarifaire",
                        "en": "Pricing Policy"
                    },
                    "children": [
                        {
                            "name": "topicPricing",
                            "labels": {
                                "fr": "Prix",
                                "en": "Pricing"
                            },
                            "polarized": true,
                            "color": "#003591"
                        },
                        {
                            "name": "topicShippingCost",
                            "labels": {
                                "fr": "Frais de livraison",
                                "en": "ShippingCost"
                            },
                            "polarized": true,
                            "color": "neutral"
                        },
                        {
                            "name": "topicShippingCostTest",
                            "labels": {
                                "fr": "Frais de livraison TEST",
                                "en": "ShippingCost"
                            },
                            "polarized": true,
                            "color": "positive"
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "offer",
                    "labels": {
                        "fr": "Offre",
                        "en": "Commercial Offer"
                    },
                    "children": [
                        {
                            "name": "topicQuestionAboutAvailablity",
                            "labels": {
                                "fr": "Dispo produits",
                                "en": "Availablity"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicQuestionChooseProduct",
                            "labels": {
                                "fr": "Infos Produit",
                                "en": "Question Choose Product"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOutOfStock",
                            "labels": {
                                "fr": "Produit indisponible",
                                "en": "Out of Stock"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOutOfStockTest",
                            "labels": {
                                "fr": "Produit indisponible TEST",
                                "en": "Out of Stock"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOpinionChoice",
                            "labels": {
                                "fr": "Gamme",
                                "en": "Product choice"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicProductQuality",
                            "labels": {
                                "fr": "Qualité du Produit",
                                "en": "Product Quality"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicSample",
                            "labels": {
                                "fr": "Echantillons",
                                "en": "Samples"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "commercialactivity",
                    "labels": {
                        "fr": "Activité commerciale",
                        "en": "Commercial Activity"
                    },
                    "children": [
                        {
                            "name": "topicEventSales",
                            "labels": {
                                "fr": "Soldes",
                                "en": "Sales"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicPrivateSales",
                            "labels": {
                                "fr": "Ventes Privées",
                                "en": "Private Sales"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicQuestionPromos",
                            "labels": {
                                "fr": "Questions promos",
                                "en": "Promos Questions"
                            },
                            "polarized": false
                        },
                        {
                            "name": "PromoCoupon",
                            "labels": {
                                "fr": "Code Promo",
                                "en": "Promo Coupon Bug"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicSpecialOfferForgotten",
                            "labels": {
                                "fr": "Code Promo Oublié",
                                "en": "Promo Coupon Forgotten"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicPromoOfferApplication",
                            "labels": {
                                "fr": "Application promo",
                                "en": "Promotional Offer Application"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOpinionPromo",
                            "labels": {
                                "fr": "Avis promos",
                                "en": "Promo Opinions"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "loyaltyprogramme",
                    "labels": {
                        "fr": "Programme de fidelité",
                        "en": "Loyalty Card"
                    },
                    "children": [
                        {
                            "name": "topicMembershipProgramme",
                            "labels": {
                                "fr": "Adhésion au programme",
                                "en": "Membership Programme"
                            },
                            "polarized": false
                        },
                        {
                            "name": "CardOpinion",
                            "labels": {
                                "fr": "Avis carte",
                                "en": "Card Opinion"
                            },
                            "polarized": false
                        },
                        {
                            "name": "AccumulateLoyaltyPoints",
                            "labels": {
                                "fr": "Cumuler pts fid",
                                "en": "Accumulate Loyalty Points"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicLoyaltyProgrammOpinion",
                            "labels": {
                                "fr": "Avis Programme Fid",
                                "en": "Loyalty Programm"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicMembershipCard",
                            "labels": {
                                "fr": "Adhésion carte",
                                "en": "Membership Card"
                            },
                            "polarized": false
                        },
                        {
                            "name": "IssueCofinogaCard",
                            "labels": {
                                "fr": "Pbs carte Cofinoga",
                                "en": "Issue Cofinoga Card"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "website",
                    "labels": {
                        "fr": "Site web / Espace Client",
                        "en": "Website / Customer Space"
                    },
                    "children": [
                        {
                            "name": "topicErgonomicWebsite",
                            "labels": {
                                "fr": "Ergonomie",
                                "en": "Ergonomic"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicDesignWebsite",
                            "labels": {
                                "fr": "Design",
                                "en": "Design"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicProductDescriptionWebsite",
                            "labels": {
                                "fr": "Description produits",
                                "en": "Product Description"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicBugs",
                            "labels": {
                                "fr": "Erreurs techniques",
                                "en": "Bugs"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicGeneralOpinionWebsite",
                            "labels": {
                                "fr": "Avis site",
                                "en": "General Opinion"
                            },
                            "polarized": true
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "order",
                    "labels": {
                        "fr": "Passer Commande",
                        "en": "Placing Order"
                    },
                    "children": [
                        {
                            "name": "IntentToPlaceOrder",
                            "labels": {
                                "fr": "Passer commande",
                                "en": "Placing Order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicPayment",
                            "labels": {
                                "fr": "Payer ma commande",
                                "en": "Payment Method Accepted"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "resa",
                    "labels": {
                        "fr": "E-réservation",
                        "en": "EReservation"
                    },
                    "children": [
                        {
                            "name": "topicQuestionBookingOrder",
                            "labels": {
                                "fr": "Modalités E-réservation",
                                "en": "Questions sur la réservation"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicIssueForBookingOrder",
                            "labels": {
                                "fr": "Pb pour réserver",
                                "en": "Pb pour réserver"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOpinionBooking",
                            "labels": {
                                "fr": "Avis E-réservation",
                                "en": "topic Opinion Booking"
                            },
                            "polarized": true
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "afterorder",
                    "labels": {
                        "fr": "Après la commande",
                        "en": "After the Order"
                    },
                    "children": [
                        {
                            "name": "ModifyOrder",
                            "labels": {
                                "fr": "Modifier ma Commande",
                                "en": "Modify Order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "IntentToCancelOrder",
                            "labels": {
                                "fr": "Annuler ma commande",
                                "en": "Cancel Order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "InformationCancelOrderBrand",
                            "labels": {
                                "fr": "Commande annulée",
                                "en": "My order has been canceled"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicTrackingOrderInformations",
                            "labels": {
                                "fr": "Suivre ma commande",
                                "en": "Track Order Informations"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicExchangeOrder",
                            "labels": {
                                "fr": "Echange commande",
                                "en": "Exchange Order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "IntentReturnOrder",
                            "labels": {
                                "fr": "Retour commande",
                                "en": "Return Order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicRefundOrder",
                            "labels": {
                                "fr": "Remboursement",
                                "en": "Refund Order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "IntentCollectOrder",
                            "labels": {
                                "fr": "Retirer ma commande",
                                "en": "Intent to collect order"
                            },
                            "polarized": false
                        },
                        {
                            "name": "Invoice",
                            "labels": {
                                "fr": "Demande de facture",
                                "en": "Invoice"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "deliveryinformations",
                    "labels": {
                        "fr": "Avant de me faire livrer",
                        "en": "Delivery Informations"
                    },
                    "children": [
                        {
                            "name": "topicOpinionDeliveryMode",
                            "labels": {
                                "fr": "Mode de livraison",
                                "en": "Delivery Method"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOpinionDeliveryModeTest",
                            "labels": {
                                "fr": "Mode de livraison TEST",
                                "en": "Delivery Method"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicModifyShippingAddress",
                            "labels": {
                                "fr": "Adresse de Livraison",
                                "en": "Shipping Address"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "delivery",
                    "labels": {
                        "fr": "Suivi de livraison",
                        "en": "Delivery"
                    },
                    "children": [
                        {
                            "name": "LateDelivery",
                            "labels": {
                                "fr": "Retard de Livraison",
                                "en": "Late Delivery"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOpinionDelivery",
                            "labels": {
                                "fr": "Avis sur la Livraison",
                                "en": "Opinion On Delivery"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicOpinionDeliveryTime",
                            "labels": {
                                "fr": "Horaires de Livraison",
                                "en": "Delivery Time"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicDeliveredToWrongPlace",
                            "labels": {
                                "fr": "Erreur de Livraison",
                                "en": "Delivery Time"
                            },
                            "polarized": true
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "receivedProduct",
                    "labels": {
                        "fr": "Je reçois ma commande",
                        "en": "Received Product"
                    },
                    "children": [
                        {
                            "name": "topicMissingProduct",
                            "labels": {
                                "fr": "Produit Manquant",
                                "en": "Missing Product"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicPackaging",
                            "labels": {
                                "fr": "Colis",
                                "en": "Packaging"
                            },
                            "polarized": false
                        },
                        {
                            "name": "Defective",
                            "labels": {
                                "fr": "Produit défectueux",
                                "en": "Defective Product"
                            },
                            "polarized": false
                        },
                        {
                            "name": "NonCompliant",
                            "labels": {
                                "fr": "Conformité produit",
                                "en": "Non Compliant Product"
                            },
                            "polarized": false
                        },
                        {
                            "name": "NonCompliantTEST",
                            "labels": {
                                "fr": "Conformité produit",
                                "en": "Non Compliant Product"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "beforevisitingstore",
                    "labels": {
                        "fr": "Mon magasin/Préparer ma visite",
                        "en": "Visiting Store"
                    },
                    "children": [
                        {
                            "name": "topicLocationStore",
                            "labels": {
                                "fr": "Proximité",
                                "en": "Location"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicTimeOpeningStore",
                            "labels": {
                                "fr": "Horaires",
                                "en": "Store Ppening Hours"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicStoreParking",
                            "labels": {
                                "fr": "Parking",
                                "en": "Parking"
                            },
                            "polarized": true
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "instore",
                    "labels": {
                        "fr": "Expérience en magasin",
                        "en": "In Store"
                    },
                    "children": [
                        {
                            "name": "topicGenericStore",
                            "labels": {
                                "fr": "Avis général",
                                "en": "Generic Opinion Store"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicArrangementOfStore",
                            "labels": {
                                "fr": "Aménagement",
                                "en": "Arrangement Of Store"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicAmbianceOfStore",
                            "labels": {
                                "fr": "Confort",
                                "en": "Ambiance Of Store"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicStoreSignage",
                            "labels": {
                                "fr": "Signalétique",
                                "en": "Store signage"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicStoreServices",
                            "labels": {
                                "fr": "Services",
                                "en": "Store Services"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicWaitingStore",
                            "labels": {
                                "fr": "Attente en magasin",
                                "en": "Waiting in Store"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicWaitingCheckout",
                            "labels": {
                                "fr": "Caisse",
                                "en": "Checkout"
                            },
                            "polarized": true
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "brandandproduct",
                    "labels": {
                        "fr": "Engagement",
                        "en": "Engagement"
                    },
                    "children": [
                        {
                            "name": "topicQualityOfService",
                            "labels": {
                                "fr": "Qualité de service",
                                "en": "Quality of Service"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicBrandRelationship",
                            "labels": {
                                "fr": "Relation à la Marque",
                                "en": "Brand Relationship"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicIRecommend",
                            "labels": {
                                "fr": "Je recommande",
                                "en": "I Recommend"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "customeraccount",
                    "labels": {
                        "fr": "Compte client",
                        "en": "Customer Account"
                    },
                    "children": [
                        {
                            "name": "CreateAccount",
                            "labels": {
                                "fr": "Créer mon compte",
                                "en": "Create Account"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicAccess",
                            "labels": {
                                "fr": "Accéder à mon compte",
                                "en": "Acces Account"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicCloseAccount",
                            "labels": {
                                "fr": "Supprimer mon compte",
                                "en": "Close Account"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicRegisterLoyaltyCard",
                            "labels": {
                                "fr": "Enregistrer ma CF",
                                "en": "Register Loyalty Card"
                            },
                            "polarized": false
                        },
                        {
                            "name": "IntentToModifyDetails",
                            "labels": {
                                "fr": "Modifier mes coordonnées",
                                "en": "Modify details"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicOptIn",
                            "labels": {
                                "fr": "Abonnement/News",
                                "en": "Opt-In"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "contact",
                    "labels": {
                        "fr": "Contacter le Service Client",
                        "en": "Contact"
                    },
                    "children": [
                        {
                            "name": "topicContactBrand",
                            "labels": {
                                "fr": "Joignabilité",
                                "en": "Contact GL"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "staff",
                    "labels": {
                        "fr": "Equipe",
                        "en": "Staff"
                    },
                    "children": [
                        {
                            "name": "topicAmability",
                            "labels": {
                                "fr": "Amabilité",
                                "en": "Amability"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicCompetency",
                            "labels": {
                                "fr": "Compétence",
                                "en": "Competency"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicAttentiveness",
                            "labels": {
                                "fr": "Ecoute",
                                "en": "Attentiveness"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicEfficiency",
                            "labels": {
                                "fr": "Rapidité",
                                "en": "Efficiency"
                            },
                            "polarized": true
                        },
                        {
                            "name": "topicDisponibility",
                            "labels": {
                                "fr": "Disponibilité",
                                "en": "Disponibility"
                            },
                            "polarized": true
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "nonactionable",
                    "labels": {
                        "fr": "Non Actionnables",
                        "en": "Non Actionnable"
                    },
                    "children": [
                        {
                            "name": "topicNonActionable",
                            "labels": {
                                "fr": "Non Actionnables",
                                "en": "Non Actionnable"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                }
            ]
        },
        "enhancement.categories.emotion": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Emotions",
                "en": "Emotions"
            },
            "hierarchical": true,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 103
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 103
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 103
                }
            },
            "values": [
                {
                    "name": "satisfaction",
                    "labels": {
                        "fr": "Satisfaction",
                        "en": "Satisfaction"
                    },
                    "children": [
                        {
                            "name": "topicSatisfaction",
                            "labels": {
                                "fr": "Satisfait",
                                "en": "Satisfaction"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "anger",
                    "labels": {
                        "fr": "En colère",
                        "en": "Anger"
                    },
                    "children": [
                        {
                            "name": "topicAnger",
                            "labels": {
                                "fr": "En Colère",
                                "en": "Anger"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicEmbarrassment",
                            "labels": {
                                "fr": "Embarrasé",
                                "en": "Embarrassment"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicShock",
                            "labels": {
                                "fr": "Choqué",
                                "en": "Shock"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "fear",
                    "labels": {
                        "fr": "Peur",
                        "en": "Fear"
                    },
                    "children": [
                        {
                            "name": "topicFear",
                            "labels": {
                                "fr": "Inquiet",
                                "en": "Fear"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "sadness",
                    "labels": {
                        "fr": "Triste",
                        "en": "Sadness"
                    },
                    "children": [
                        {
                            "name": "topicSadness",
                            "labels": {
                                "fr": "Triste",
                                "en": "Sadness"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicDisappointment",
                            "labels": {
                                "fr": "Déçu",
                                "en": "Disappointment"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "dissatisfaction",
                    "labels": {
                        "fr": "Insatisfait",
                        "en": "Dissatisfaction"
                    },
                    "children": [
                        {
                            "name": "topicDissatisfaction",
                            "labels": {
                                "fr": "Insatisfait",
                                "en": "Dissatisfaction"
                            },
                            "polarized": false
                        },
                        {
                            "name": "topicDoubt",
                            "labels": {
                                "fr": "Doute",
                                "en": "Doubt"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                },
                {
                    "name": "reaction",
                    "labels": {
                        "fr": "Réaction",
                        "en": "Reaction"
                    },
                    "children": [
                        {
                            "name": "topicSurprise",
                            "labels": {
                                "fr": "Surpris",
                                "en": "Surprise"
                            },
                            "polarized": false
                        }
                    ],
                    "polarized": false
                }
            ]
        },
        "enhancement.categories.risk": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Intentions de mes clients",
                "en": "Risks"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 104
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 104
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 104
                }
            },
            "values": [
                {
                    "name": "callCustomerService",
                    "labels": {
                        "fr": "Effort Client",
                        "en": "Asking for recall"
                    },
                    "polarized": false
                },
                {
                    "name": "churn",
                    "labels": {
                        "fr": "Churn",
                        "en": "Churn"
                    },
                    "polarized": false
                },
                {
                    "name": "legal",
                    "labels": {
                        "fr": "Litige",
                        "en": "Legal Risk"
                    },
                    "polarized": false
                },
                {
                    "name": "NotWarned",
                    "labels": {
                        "fr": "Non prévenu",
                        "en": "Not warned"
                    },
                    "polarized": false
                },
                {
                    "name": "Fraud",
                    "labels": {
                        "fr": "Fraude",
                        "en": "Fraud"
                    },
                    "polarized": false
                },
                {
                    "name": "riskReputation",
                    "labels": {
                        "fr": "Mauvaise Réputation",
                        "en": "Reputation"
                    },
                    "polarized": false
                },
                {
                    "name": "UnkeptCommitment",
                    "labels": {
                        "fr": "Engagements non tenus",
                        "en": "Unkept commitment"
                    },
                    "polarized": false
                },
                {
                    "name": "askingForRecall",
                    "labels": {
                        "fr": "Demandes de rappel",
                        "en": "Recall"
                    },
                    "polarized": false
                },
                {
                    "name": "Harassment",
                    "labels": {
                        "fr": "Harcèlement",
                        "en": "Harassment"
                    },
                    "polarized": false
                }
            ]
        },
        "enhancement.satisfaction": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Satisfaction Client",
                "en": "Sentiment"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": true,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 105
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 105
                },
                "feedbackDetailsView": {
                    "enabled": false,
                    "order": 105
                }
            },
            "values": [
                {
                    "name": "negative",
                    "labels": {
                        "fr": "Négative",
                        "en": "Negative"
                    },
                    "polarized": false
                },
                {
                    "name": "positive",
                    "labels": {
                        "fr": "Positive",
                        "en": "Positive"
                    },
                    "polarized": false
                },
                {
                    "name": "mixed",
                    "labels": {
                        "fr": "Mitigé",
                        "en": "Mixed"
                    },
                    "polarized": false
                },
                {
                    "name": "neutral",
                    "labels": {
                        "fr": "Neutre",
                        "en": "Neutral"
                    },
                    "polarized": false
                }
            ]
        },
        "enhancement.categories.satisfaction": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Satisfaction Client",
                "en": "Sentiment"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": false,
                    "order": 106
                },
                "dashboardFilterView": {
                    "enabled": false,
                    "order": 106
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 106
                }
            },
            "values": [
                {
                    "name": "negative",
                    "labels": {
                        "fr": "Négative",
                        "en": "Negative"
                    },
                    "polarized": false
                },
                {
                    "name": "positive",
                    "labels": {
                        "fr": "Positive",
                        "en": "Positive"
                    },
                    "polarized": false
                }
            ]
        },
        "enhancement.categories.tag": {
            "@version": "1",
            "enabled": false,
            "labels": {
                "fr": "Tags",
                "en": "Tags"
            },
            "hierarchical": true,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 105
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 105
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 105
                }
            }
        },
        "enhancement.nps": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "NPS",
                "en": "NPS"
            },
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 108
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 108
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 108
                }
            },
            "values": [
                {
                    "name": "1",
                    "labels": {
                        "fr": "Promoteurs",
                        "en": "Promoters"
                    },
                    "polarized": false
                },
                {
                    "name": "-1",
                    "labels": {
                        "fr": "Détracteurs",
                        "en": "Detractors"
                    },
                    "polarized": false
                },
                {
                    "name": "0",
                    "labels": {
                        "fr": "Passifs",
                        "en": "Passives"
                    },
                    "polarized": false
                }
            ]
        },
        "enhancement.computational.nps100": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "NPS",
                "en": "NPS"
            },
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.recommendationScore": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Score de recommandation",
                "en": "Recommendation score"
            },
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": false,
                    "order": 202
                },
                "dashboardFilterView": {
                    "enabled": false,
                    "order": 202
                },
                "feedbackDetailsView": {
                    "enabled": false,
                    "order": 202
                }
            }
        },
        "metadata.custom.veckoFilename": {
            "@version": "1",
            "enabled": false,
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.month": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.subject": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "verbatim": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.place_name": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Magasin",
                "en": "Store"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 110
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 110
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 110
                },
                "dynamicDashboardSelector": {
                    "enabled": true,
                    "order": 110
                },
                "topicsStatListView": {
                    "enabled": true,
                    "order": 10
                }
            }
        },
        "metadata.custom.place_levels_Regroupement_Bu": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Regroupement BU",
                "en": "BU"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 111
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 111
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 111
                },
                "dynamicDashboardSelector": {
                    "enabled": false,
                    "order": 111
                }
            }
        },
        "metadata.custom.place_levels_Enseigne": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Enseigne",
                "en": "Company"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 111
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 111
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 111
                },
                "dynamicDashboardSelector": {
                    "enabled": false,
                    "order": 111
                }
            }
        },
        "metadata.custom.place_levels_Canal": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Canal",
                "en": "Channel"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 111
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 111
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 111
                },
                "dynamicDashboardSelector": {
                    "enabled": false,
                    "order": 111
                }
            }
        },
        "metadata.custom.context_cz_tag": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Parcours",
                "en": "Journey"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 112
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 112
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 112
                }
            }
        },
        "metadata.custom.context_extra_order_type": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Type d'achat",
                "en": "Purchase Type"
            },
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 113
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 113
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 113
                }
            }
        },
        "metadata.custom.context_extra_brand": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Marques",
                "en": "Brands"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 114
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 114
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 114
                },
                "dynamicDashboardSelector": {
                    "enabled": true,
                    "order": 114
                }
            }
        },
        "metadata.custom.context_extra_fid": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Fidélité",
                "en": "Loyalty"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 115
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 115
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 115
                }
            }
        },
        "metadata.custom.context_extra_statut_pqsta_fidgl": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Statut Fidélité",
                "en": "Loyalty Status"
            },
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {
                    "enabled": true,
                    "order": 116
                },
                "dashboardFilterView": {
                    "enabled": true,
                    "order": 116
                },
                "feedbackDetailsView": {
                    "enabled": true,
                    "order": 116
                }
            }
        },
        "metadata.custom.conversation": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.idUser": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.lazy": {
            "@version": "1",
            "enabled": true,
            "labels": {
                "fr": "Paresseux",
                "en": "Lazy"
            },
            "hierarchical": false,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {
                    "enabled": false,
                    "order": 1
                },
                "dashboardFilterView": {
                    "enabled": false,
                    "order": 1
                },
                "feedbackDetailsView": {
                    "enabled": false,
                    "order": 1
                }
            },
            "values": [
                {
                    "name": "value1",
                    "labels": {
                        "fr": "valeur 1",
                        "en": "value 1"
                    },
                    "polarized": false
                },
                {
                    "name": "value2",
                    "labels": {
                        "fr": "valeur 2",
                        "en": "value 2"
                    },
                    "polarized": false
                }
            ]
        },
        "int": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        }
    },
    "fieldsValue": {
        "metadata.standard.channelName": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ],
        "metadata.custom.place_name": [
            {
                "value": "BHV Marais"
            },
            {
                "value": "GaleriesLafayette.com"
            },
            {
                "value": "Galeries Lafayette HAUSSMANN"
            },
            {
                "value": "Galeries Lafayette Maine Montparnasse"
            },
            {
                "value": "BHV Parly 2"
            },
            {
                "value": "Galeries Lafayette Toulouse Lapeyrouse"
            },
            {
                "value": "Galeries Lafayette Nice Cap 3000"
            },
            {
                "value": "Galeries Lafayette Lyon Bron"
            },
            {
                "value": "Galeries Lafayette Bordeaux"
            },
            {
                "value": "Galeries Lafayette Nice Massena"
            },
            {
                "value": "Galeries Lafayette Strasbourg"
            },
            {
                "value": "Galeries Lafayette Nantes Decre"
            },
            {
                "value": "Galeries Lafayette Lyon Part Dieu"
            },
            {
                "value": "Galeries Lafayette Marseille Bourse"
            },
            {
                "value": "Galeries Lafayette Montpellier"
            },
            {
                "value": "Galeries Lafayette Perpignan"
            },
            {
                "value": "Galeries Lafayette Annecy"
            },
            {
                "value": "Galeries Lafayette Avignon"
            },
            {
                "value": "bhv.fr"
            },
            {
                "value": "Galeries Lafayette Marseille Prado"
            },
            {
                "value": "Galeries Lafayette Metz"
            },
            {
                "value": "Galeries Lafayette Rennes"
            },
            {
                "value": "Galeries Lafayette Rosny"
            },
            {
                "value": "Galeries Lafayette Carre-Senart"
            },
            {
                "value": "Galeries Lafayette Dijon"
            },
            {
                "value": "Galeries Lafayette Grenoble"
            },
            {
                "value": "Galeries Lafayette Orleans"
            },
            {
                "value": "Galeries Lafayette Reims"
            },
            {
                "value": "Galeries Lafayette Clermont Ferrand"
            },
            {
                "value": "Galeries Lafayette Biarritz"
            },
            {
                "value": "Galeries Lafayette Tours"
            },
            {
                "value": "BHV Limonest"
            },
            {
                "value": "Galeries Lafayette Caen"
            },
            {
                "value": "Galeries Lafayette Bayonne"
            },
            {
                "value": "Galeries Lafayette Angers"
            },
            {
                "value": "Galeries Lafayette Rouen"
            },
            {
                "value": "Galeries Lafayette Amiens"
            },
            {
                "value": "Galeries Lafayette Besançon"
            },
            {
                "value": "Galeries Lafayette Toulon"
            },
            {
                "value": "Galeries Lafayette Le Mans"
            },
            {
                "value": "Galeries Lafayette Limoges"
            },
            {
                "value": "Galeries Lafayette La Rochelle"
            },
            {
                "value": "Galeries Lafayette l'Outlet ONE NATION"
            },
            {
                "value": "Galeries Lafayette Cannes"
            },
            {
                "value": "Galeries Lafayette Lorient"
            },
            {
                "value": "Galeries Lafayette Béziers"
            },
            {
                "value": "Galeries Lafayette l'Outlet NAILLOUX"
            },
            {
                "value": "Galeries Lafayette La Roche-sur-Yon"
            },
            {
                "value": "Galeries Lafayette l'Outlet ROUBAIX"
            },
            {
                "value": "Galeries Lafayette Beauvais"
            },
            {
                "value": "Galeries Lafayette Montauban"
            },
            {
                "value": "Galeries Lafayette Dax"
            },
            {
                "value": "Galeries Lafayette l'Outlet THE VILLAGE"
            },
            {
                "value": "Galeries Lafayette Tarbes"
            },
            {
                "value": "Galeries Lafayette Belfort"
            },
            {
                "value": "Galeries Lafayette Agen"
            },
            {
                "value": "Galeries Lafayette Chalon-sur-Saône"
            },
            {
                "value": "Galeries Lafayette l'Outlet HONFLEUR"
            },
            {
                "value": "Galeries Lafayette l'Outlet LA SEGUINIERE"
            },
            {
                "value": "Galeries Lafayette l'Outlet TALANGE"
            },
            {
                "value": "Galeries Lafayette l'Outlet COQUELLES"
            },
            {
                "value": "Galeries Lafayette Saintes"
            },
            {
                "value": "Galeries Lafayette Pau"
            },
            {
                "value": "BHV Part Dieu"
            },
            {
                "value": "Galeries Lafayette Champs-Elysées"
            },
            {
                "value": "Galeries Lafayette Chambéry"
            },
            {
                "value": "Galeries Lafayette Niort"
            },
            {
                "value": "Galeries Lafayette Langon"
            },
            {
                "value": "Galeries Lafayette Angoulême"
            },
            {
                "value": "Galeries Lafayette Libourne"
            },
            {
                "value": "Galeries Lafayette Menton"
            },
            {
                "value": "L'Usine Mode et Maison VELIZY"
            },
            {
                "value": "Galeries Lafayette l'Outlet ROPPENHEIM"
            },
            {
                "value": "Galeries Lafayette l’Outlet L’ÎLE SAINT-DENIS"
            },
            {
                "value": "Eataly Paris Marais"
            }
        ],
        "metadata.custom.place_levels_Regroupement_Bu": [
            {
                "value": "Réseau GL"
            },
            {
                "value": "Magasins BHV"
            },
            {
                "value": "GL.com"
            },
            {
                "value": "Affiliés GL"
            },
            {
                "value": "Haussmann"
            },
            {
                "value": "Outlets"
            },
            {
                "value": "bhv.fr"
            },
            {
                "value": "Champs-Elysées"
            }
        ],
        "metadata.custom.place_levels_Enseigne": [
            {
                "value": "Galeries Lafayette"
            },
            {
                "value": "Le BHV"
            },
            {
                "value": "Galeries Lafayette l'Outlet"
            },
            {
                "value": "Eataly"
            }
        ],
        "metadata.custom.place_levels_Canal": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ],
        "metadata.custom.context_cz_tag": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ],
        "metadata.custom.context_extra_order_type": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ],
        "metadata.custom.context_extra_brand": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ],
        "metadata.custom.context_extra_fid": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ],
        "metadata.custom.context_extra_statut_pqsta_fidgl": [
            {
                "value": "value1"
            },
            {
                "value": "value2"
            },
            {
                "value": "value3"
            }
        ]
    }
}


const test = {
    "filter": {"dateRange": {"start": "2020-12-01", "end": "2021-12-01", "zoneId": "Indian/Mauritius"}}, "dashboard": {
        "id": "test",
        "data": {
            "hasData": true,
            "payload": {
                "globalSatScore": {
                    "value": 28,
                    "count": 3213,
                    "trend": -14,
                    "from": "2020-11-30T20:00:00.000Z",
                    "to": "2021-11-30T20:00:00.000Z",
                    "distribution": {"NEGATIVE": 1505, "POSITIVE": 866, "NEUTRAL": 842},
                    "comparison": {
                        "value": -17,
                        "count": 4657,
                        "trend": 46,
                        "from": "2020-11-30T20:00:00.000Z",
                        "to": "2021-11-30T20:00:00.000Z",
                        "distribution": {"NEGATIVE": 2062, "POSITIVE": 1633, "NEUTRAL": 962}
                    }
                },
                "bestTopicsRanking": [{
                    "category": "pricingpolicy/topicPricing",
                    "values": {
                        "SAT_SCORE": 28,
                        "VOLUME": 800,
                        "TREND": -4,
                        "POSITIVE_OPINIONS": 1,
                        "NEGATIVE_OPINIONS": 16
                    },
                    "rank": 1,
                    "highlighted": false
                }, {
                    "category": "pricingpolicy/topicShippingCost",
                    "values": {
                        "SAT_SCORE": 34,
                        "VOLUME": 246,
                        "TREND": -9,
                        "POSITIVE_OPINIONS": 3,
                        "NEGATIVE_OPINIONS": 44
                    },
                    "rank": 2,
                    "highlighted": false
                }, {
                    "category": "pricingpolicy/topicShippingCostTest",
                    "values": {
                        "SAT_SCORE": 89,
                        "VOLUME": 672,
                        "TREND": -6,
                        "POSITIVE_OPINIONS": 44,
                        "NEGATIVE_OPINIONS": 2
                    },
                    "rank": 3,
                    "highlighted": false
                }, {
                    "category": "offer/topicQuestionAboutAvailablity",
                    "values": {
                        "SAT_SCORE": 95,
                        "VOLUME": 621,
                        "TREND": -9,
                        "POSITIVE_OPINIONS": 11,
                        "NEGATIVE_OPINIONS": 14
                    },
                    "rank": 4,
                    "highlighted": false
                }, {
                    "category": "offer/topicQuestionChooseProduct",
                    "values": {
                        "SAT_SCORE": 39,
                        "VOLUME": 598,
                        "TREND": 9,
                        "POSITIVE_OPINIONS": 49,
                        "NEGATIVE_OPINIONS": 42
                    },
                    "rank": 5,
                    "highlighted": false
                }],
                "worstTopicsRanking": [{
                    "category": "pricingpolicy/topicPricing",
                    "values": {
                        "SAT_SCORE": -2,
                        "VOLUME": 606,
                        "TREND": -9,
                        "POSITIVE_OPINIONS": 37,
                        "NEGATIVE_OPINIONS": 24
                    },
                    "rank": 1,
                    "highlighted": false
                }, {
                    "category": "pricingpolicy/topicShippingCost",
                    "values": {
                        "SAT_SCORE": 89,
                        "VOLUME": 79,
                        "TREND": -7,
                        "POSITIVE_OPINIONS": 11,
                        "NEGATIVE_OPINIONS": 40
                    },
                    "rank": 2,
                    "highlighted": false
                }, {
                    "category": "pricingpolicy/topicShippingCostTest",
                    "values": {
                        "SAT_SCORE": 50,
                        "VOLUME": 692,
                        "TREND": 8,
                        "POSITIVE_OPINIONS": 21,
                        "NEGATIVE_OPINIONS": 8
                    },
                    "rank": 3,
                    "highlighted": false
                }, {
                    "category": "offer/topicQuestionAboutAvailablity",
                    "values": {
                        "SAT_SCORE": -100,
                        "VOLUME": 530,
                        "TREND": 3,
                        "POSITIVE_OPINIONS": 11,
                        "NEGATIVE_OPINIONS": 34
                    },
                    "rank": 4,
                    "highlighted": false
                }, {
                    "category": "offer/topicQuestionChooseProduct",
                    "values": {
                        "SAT_SCORE": 60,
                        "VOLUME": 834,
                        "TREND": 3,
                        "POSITIVE_OPINIONS": 6,
                        "NEGATIVE_OPINIONS": 46
                    },
                    "rank": 5,
                    "highlighted": false
                }],
                "bestTopics": [{
                    "topic": "pricingpolicy/topicShippingCostTest",
                    "score": 86,
                    "trend": -1,
                    "count": 199,
                    "feedback": {
                        "verbatims": [{
                            "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                            "offsets": [{
                                "tree": "topic",
                                "start": 114,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "instore/topicGenericStore"
                            }, {
                                "tree": "emotion",
                                "start": 129,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 15,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 95}, {
                                "ordinal": 2,
                                "start": 95,
                                "end": 154
                            }, {"ordinal": 3, "start": 154, "end": 179}]
                        }],
                        "enhancement": {
                            "satisfaction": "NEGATIVE",
                            "categories": {
                                "topic": ["instore/topicGenericStore"],
                                "satisfaction": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "U8XmDBos4O"
                            }
                        },
                        "date": 1638351348861,
                        "satMood": "POSITIVE",
                        "satScore": 9,
                        "satType": "NPS",
                        "id": 0
                    }
                }, {
                    "topic": "pricingpolicy/topicPricing", "score": 84, "trend": -1, "count": 240, "feedback": {
                        "id": 0,
                        "date": 1638351348862,
                        "verbatims": [{
                            "content": "bonjour",
                            "type": "chat customer",
                            "sender": "LV1MNEVRIL",
                            "customer": true,
                            "offsets": [],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 7}]
                        }, {
                            "content": "Comment puis-je vous aider?",
                            "type": "chat agent",
                            "sender": "srivier",
                            "customer": false
                        }, {
                            "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                            "type": "chat customer",
                            "sender": "LV1MNEVRIL",
                            "customer": true,
                            "offsets": [{
                                "tree": "topic",
                                "category": "instore/topicGenericStore",
                                "start": 86,
                                "end": 107,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                "start": 14,
                                "end": 17,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                "start": 144,
                                "end": 150,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                "start": 144,
                                "end": 150,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                "start": 52,
                                "end": 61,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "stock-fr-FR/argumentProductPackaging",
                                "start": 52,
                                "end": 61,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "stock-fr-FR/circonstantSoon",
                                "start": 94,
                                "end": 107,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "patternsandtools-fr-FR/Speaker",
                                "start": 123,
                                "end": 125,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                "start": 86,
                                "end": 93,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "packaging-fr-FR/argumentPackaging",
                                "start": 52,
                                "end": 61,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "productfeatures-fr-FR/dialogActWhere",
                                "start": 108,
                                "end": 110,
                                "tonality": "NEUTRAL"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 152}]
                        }, {
                            "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                            "type": "chat agent",
                            "sender": "srivier",
                            "customer": false
                        }, {
                            "content": "k c est super ...merci pour l info    bonne fin de journée",
                            "type": "chat customer",
                            "sender": "LV1MNEVRIL",
                            "customer": true,
                            "offsets": [{
                                "tree": "tag",
                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                "start": 28,
                                "end": 43,
                                "tonality": "POSITIVE"
                            }, {
                                "tree": "tag",
                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                "start": 17,
                                "end": 34,
                                "tonality": "POSITIVE"
                            }, {
                                "tree": "tag",
                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                "start": 2,
                                "end": 15,
                                "tonality": "POSITIVE"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 17}, {"ordinal": 2, "start": 17, "end": 58}]
                        }, {
                            "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                            "type": "chat agent",
                            "sender": "srivier",
                            "customer": false
                        }],
                        "enhancement": {"satisfaction": "NEUTRAL"},
                        "metadata": {
                            "standard": {"channelKind": "chat"},
                            "custom": {"context_extra_fid": "nrpRT07ES6"}
                        },
                        "satMood": "POSITIVE",
                        "satScore": 6,
                        "satType": "NPS"
                    }
                }, {
                    "topic": "pricingpolicy/topicShippingCost", "score": 57, "trend": -1, "count": 216, "feedback": {
                        "id": 0,
                        "date": 1638351348862,
                        "verbatims": [{
                            "content": "bonjour",
                            "type": "chat customer",
                            "sender": "LV1MNEVRIL",
                            "customer": true,
                            "offsets": [],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 7}]
                        }, {
                            "content": "Comment puis-je vous aider?",
                            "type": "chat agent",
                            "sender": "srivier",
                            "customer": false
                        }, {
                            "content": "concernant ma cde W0#####1 il reste en reliquat des pochettes d'expedition\nseront ils livrées prochainement ou faut il que je choissir un autre modele ?",
                            "type": "chat customer",
                            "sender": "LV1MNEVRIL",
                            "customer": true,
                            "offsets": [{
                                "tree": "topic",
                                "category": "instore/topicGenericStore",
                                "start": 86,
                                "end": 107,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "refundorder-fr-FR/argumentOrderCandidate",
                                "start": 14,
                                "end": 17,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "refundorder-fr-FR/argumentProductCandidate",
                                "start": 144,
                                "end": 150,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "receivedproduct-fr-FR/argumentProductCandidate",
                                "start": 144,
                                "end": 150,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "refundorder-fr-FR/argumentProductPackaging",
                                "start": 52,
                                "end": 61,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "stock-fr-FR/argumentProductPackaging",
                                "start": 52,
                                "end": 61,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "stock-fr-FR/circonstantSoon",
                                "start": 94,
                                "end": 107,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "patternsandtools-fr-FR/Speaker",
                                "start": 123,
                                "end": 125,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "receivedproduct-fr-FR/predicateDelivered",
                                "start": 86,
                                "end": 93,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "packaging-fr-FR/argumentPackaging",
                                "start": 52,
                                "end": 61,
                                "tonality": "NEUTRAL"
                            }, {
                                "tree": "tag",
                                "category": "productfeatures-fr-FR/dialogActWhere",
                                "start": 108,
                                "end": 110,
                                "tonality": "NEUTRAL"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 152}]
                        }, {
                            "content": "Un instant je vous prie.\nLe produit est prévu en livraison le 03/12 au plus tard.",
                            "type": "chat agent",
                            "sender": "srivier",
                            "customer": false
                        }, {
                            "content": "k c est super ...merci pour l info    bonne fin de journée",
                            "type": "chat customer",
                            "sender": "LV1MNEVRIL",
                            "customer": true,
                            "offsets": [{
                                "tree": "tag",
                                "category": "qualityofservice-fr-FR/topicOpinionNotConjugatedQualityResponse",
                                "start": 28,
                                "end": 43,
                                "tonality": "POSITIVE"
                            }, {
                                "tree": "tag",
                                "category": "staff-fr-FR/topicOpinionConjugateQualityInformation",
                                "start": 17,
                                "end": 34,
                                "tonality": "POSITIVE"
                            }, {
                                "tree": "tag",
                                "category": "satisfied-fr-FR/topicNonActionableSatisfied",
                                "start": 2,
                                "end": 15,
                                "tonality": "POSITIVE"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 17}, {"ordinal": 2, "start": 17, "end": 58}]
                        }, {
                            "content": "Je vous en prie.\nJe vous souhaite une agréable journée. A très bientôt sur le Chat Raja.",
                            "type": "chat agent",
                            "sender": "srivier",
                            "customer": false
                        }],
                        "enhancement": {"satisfaction": "NEUTRAL"},
                        "metadata": {
                            "standard": {"channelKind": "chat"},
                            "custom": {"context_extra_fid": "ntBE69OcOG"}
                        },
                        "satMood": "POSITIVE",
                        "satScore": 4,
                        "satType": "NPS"
                    }
                }],
                "worstTopics": [{
                    "topic": "pricingpolicy/topicShippingCostTest",
                    "score": -78,
                    "trend": -1,
                    "count": 142
                }, {
                    "topic": "pricingpolicy/topicShippingCost",
                    "score": -50,
                    "trend": 1,
                    "count": 515
                }, {"topic": "pricingpolicy/topicPricing", "score": -34, "trend": -1, "count": 185}],
                "distribution": {
                    "total": 64,
                    "distribution": [{"value": "value1", "count": 14, "trend": -4}, {
                        "value": "value2",
                        "count": 49,
                        "trend": -3
                    }, {"value": "value3", "count": 1, "trend": 10}]
                },
                "customerJourneySat": {
                    "offer": [{
                        "topic": "offer",
                        "score": -31,
                        "count": 73,
                        "trend": 4,
                        "distribution": {"NEGATIVE": 53, "POSITIVE": 12, "NEUTRAL": 8}
                    }, {
                        "topic": "brandandproduct",
                        "score": -16,
                        "count": 91,
                        "trend": 6,
                        "distribution": {"NEGATIVE": 60, "POSITIVE": 12, "NEUTRAL": 19}
                    }],
                    "ecommerce": [{
                        "topic": "order",
                        "score": 98,
                        "count": 43,
                        "trend": 0,
                        "distribution": {"NEGATIVE": 42, "POSITIVE": 1, "NEUTRAL": 0}
                    }, {
                        "topic": "afterorder",
                        "score": -100,
                        "count": 52,
                        "trend": 4,
                        "distribution": {"NEGATIVE": 51, "POSITIVE": 0, "NEUTRAL": 1}
                    }, {
                        "topic": "deliveryinformations",
                        "score": 37,
                        "count": 74,
                        "trend": -6,
                        "distribution": {"NEGATIVE": 56, "POSITIVE": 11, "NEUTRAL": 7}
                    }, {
                        "topic": "delivery",
                        "score": 39,
                        "count": 26,
                        "trend": 0,
                        "distribution": {"NEGATIVE": 26, "POSITIVE": 0, "NEUTRAL": 0}
                    }, {
                        "topic": "receivedProduct",
                        "score": 4,
                        "count": 100,
                        "trend": 1,
                        "distribution": {"NEGATIVE": 81, "POSITIVE": 2, "NEUTRAL": 17}
                    }],
                    "store": [{
                        "topic": "beforevisitingstore",
                        "score": 24,
                        "count": 45,
                        "trend": -2,
                        "distribution": {"NEGATIVE": 41, "POSITIVE": 1, "NEUTRAL": 3}
                    }, {
                        "topic": "instore",
                        "score": 4,
                        "count": 47,
                        "trend": -4,
                        "distribution": {"NEGATIVE": 45, "POSITIVE": 2, "NEUTRAL": 0}
                    }, {
                        "topic": "staff",
                        "score": -55,
                        "count": 88,
                        "trend": 4,
                        "distribution": {"NEGATIVE": 78, "POSITIVE": 0, "NEUTRAL": 10}
                    }],
                    "website": [{
                        "topic": "website",
                        "score": -79,
                        "count": 65,
                        "trend": 0,
                        "distribution": {"NEGATIVE": 40, "POSITIVE": 17, "NEUTRAL": 8}
                    }, {
                        "topic": "customeraccount",
                        "score": -36,
                        "count": 2,
                        "trend": -4,
                        "distribution": {"NEGATIVE": 2, "POSITIVE": 0, "NEUTRAL": 0}
                    }]
                }
            }
        },
        "resolvedParams": {
            "satType": {"@type": "satType", "name": "NPS"},
            "main": {
                "@type": "fieldValue",
                "field": {"@type": "field", "name": "metadata.custom.lazy"},
                "value": "value1"
            }
        }
    }, "dashboardVizEditor": {"validatedData": {}},
    "uiConfig": {
        "sat": {
            "NPS": {
                "filter": {"@type": "term", "field": "metadata.standard.channelKind", "term": "survey"},
                "scoreField": "metadata.custom.recommendationScore"
            },
            "CSAT10": {
                "filter": {"@type": "term", "field": "metadata.standard.channelKind", "term": "survey"},
                "scoreField": "metadata.custom.recommendationScore"
            }
        },
        "customerJourneys": [{
            "name": "offer",
            "labels": {"fr": "Offre", "en": "Offer"},
            "topics": ["offer", "brandandproduct"]
        }, {
            "name": "ecommerce",
            "labels": {"fr": "Commerce électronique", "en": "E-commerce"},
            "topics": ["order", "afterorder", "deliveryinformations", "delivery", "receivedProduct"]
        }, {
            "name": "store",
            "labels": {"fr": "Magasin", "en": "Store"},
            "topics": ["beforevisitingstore", "instore", "staff"]
        }, {
            "name": "website",
            "labels": {"fr": "Site internet", "en": "Web site"},
            "topics": ["website", "customeraccount"]
        }],
        "reports": [{
            "id": "test",
            "labels": {"fr": "Test", "en": "Test"},
            "metric": "satType",
            "parameters": [{
                "@type": "selector",
                "name": "satType",
                "values": {
                    "@type": "list",
                    "items": [{"@type": "satType", "name": "NPS"}, {"@type": "satType", "name": "CSAT10"}]
                }
            }, {
                "@type": "fieldAndValueSelector",
                "name": "main",
                "fields": {"@type": "list", "items": [{"@type": "field", "name": "metadata.custom.lazy"}]}
            }],
            "visualizations": [{
                "id": "globalSatScore",
                "@type": "SAT_SCORE",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"},
                    "distribution": {"enabled": true, "showNeutral": true},
                    "comparison": {"enabled": true, "mode": "LAST_12_MONTHS"}
                },
                "layout": {"page": 0, "x": 0, "y": 16, "w": 18, "h": 16}
            }, {
                "id": "bestTopicsRanking",
                "@type": "RANKING",
                "labels": {"fr": "Leviers à consolider", "en": "Areas doing well"},
                "params": {
                    "satType": "${satType}",
                    "field": "enhancement.categories.topic",
                    "count": 5,
                    "ranges": [{"metric": "SAT_SCORE", "range": {"from": 10, "to": 100}}, {
                        "metric": "VOLUME",
                        "range": {"from": 50}
                    }],
                    "exclusions": ["pricingpolicy/topicShippingCost"],
                    "inclusions": ["pricingpolicy/topicPricing"]
                },
                "uiParams": {
                    "color": "#7EBD56",
                    "hideRanks": true,
                    "canSeeMore": true,
                    "metrics": ["POSITIVE_OPINIONS", "NEGATIVE_OPINIONS", "TREND", "SAT_SCORE", "VOLUME"]
                },
                "layout": {"page": 0, "x": 18, "y": 0, "w": 15, "h": 16}
            }, {
                "id": "worstTopicsRanking",
                "@type": "RANKING",
                "labels": {"fr": "Leviers d'amélioration", "en": "Areas to improve"},
                "params": {
                    "satType": "${satType}",
                    "field": "enhancement.categories.topic",
                    "count": 5,
                    "ranges": [{"metric": "VOLUME", "range": {"from": 50}}],
                    "sort": [{"metric": "SAT_SCORE", "order": "ASC"}, {"metric": "VOLUME", "order": "DESC"}]
                },
                "uiParams": {"color": "#ef476f", "hideRanks": true, "canSeeMore": true},
                "layout": {"page": 0, "x": 33, "y": 0, "w": 15, "h": 16}
            }, {
                "id": "bestTopics",
                "@type": "TOPIC_SAT_SCORE",
                "params": {
                    "satType": "${satType}",
                    "count": 3,
                    "polarity": "POSITIVE",
                    "ranges": [{"metric": "SAT_SCORE", "range": {"from": 10, "to": 100}}, {
                        "metric": "VOLUME",
                        "range": {"from": 50}
                    }],
                    "exclusions": ["pricingpolicy/topicShippingCost"]
                },
                "layout": {"page": 0, "x": 18, "y": 16, "w": 30, "h": 14}
            }, {
                "id": "worstTopics",
                "@type": "TOPIC_SAT_SCORE",
                "params": {
                    "satType": "${satType}",
                    "count": 3,
                    "polarity": "NEGATIVE",
                    "ranges": [{"metric": "VOLUME", "range": {"from": 50}}],
                    "sort": [{"metric": "SAT_SCORE", "order": "ASC"}, {"metric": "VOLUME", "order": "DESC"}],
                    "noSamples": true
                },
                "layout": {"page": 0, "x": 18, "y": 30, "w": 30, "h": 14}
            }, {
                "id": "distribution",
                "@type": "DISTRIBUTION",
                "params": {"field": "metadata.standard.channelName"},
                "uiParams": {},
                "layout": {"page": 0, "x": 0, "y": 0, "w": 18, "h": 14}
            }, {
                "id": "customerJourneySat",
                "@type": "CUSTOMER_JOURNEY_SAT_SCORE",
                "params": {"satType": "${satType}"},
                "layout": {"page": 0, "x": 0, "y": 44, "w": 48, "h": 60}
            }]
        }]
    },
    "fields": {
        "date": {"@version": "1", "enabled": true, "hierarchical": false, "exportable": true, "polarized": false},
        "metadata.standard.channelKind": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Canal", "en": "Channel"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 1},
                "dashboardFilterView": {"enabled": true, "order": 1},
                "feedbackDetailsView": {"enabled": false, "order": 1},
                "topicsStatListView": {"enabled": false, "order": 2},
                "feedbacksListView": {"enabled": true, "order": 1}
            },
            "values": [{
                "name": "survey",
                "labels": {"fr": "Avis Client", "en": "Critizr Reviews"},
                "polarized": false
            }, {"name": "email", "labels": {"fr": "Emails", "en": "Emails"}, "polarized": false}, {
                "name": "chat",
                "labels": {"fr": "Chat Communautaire", "en": "Chat"},
                "polarized": false
            }]
        },
        "metadata.standard.channelName": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Sous Canal", "en": "Channel Name"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 2},
                "dashboardFilterView": {"enabled": true, "order": 2},
                "feedbackDetailsView": {"enabled": true, "order": 2}
            }
        },
        "metadata.standard.locale": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Langue", "en": "Locale"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 3},
                "feedbackDetailsView": {"enabled": false, "order": 3}
            },
            "values": [{
                "name": "en_GB",
                "labels": {"fr": "Anglais", "en": "English"},
                "polarized": false
            }, {"name": "fr_FR", "labels": {"fr": "Français", "en": "French"}, "polarized": false}]
        },
        "enhancement.categories.topic": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Ce que disent mes clients", "en": "Topics"},
            "hierarchical": true,
            "exportable": true,
            "polarized": true,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 102},
                "dashboardFilterView": {"enabled": false, "order": 102},
                "feedbackDetailsView": {"enabled": false, "order": 102},
                "topicsStatListView": {"enabled": false, "order": 3},
                "feedbacksListView": {"enabled": false, "order": 2}
            },
            "values": [{
                "name": "pricingpolicy",
                "labels": {"fr": "Politique tarifaire", "en": "Pricing Policy"},
                "children": [{
                    "name": "topicPricing",
                    "labels": {"fr": "Prix", "en": "Pricing"},
                    "polarized": true
                }, {
                    "name": "topicShippingCost",
                    "labels": {"fr": "Frais de livraison", "en": "ShippingCost"},
                    "polarized": true
                }, {
                    "name": "topicShippingCostTest",
                    "labels": {"fr": "Frais de livraison TEST", "en": "ShippingCost"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "offer",
                "labels": {"fr": "Offre", "en": "Commercial Offer"},
                "children": [{
                    "name": "topicQuestionAboutAvailablity",
                    "labels": {"fr": "Dispo produits", "en": "Availablity"},
                    "polarized": false
                }, {
                    "name": "topicQuestionChooseProduct",
                    "labels": {"fr": "Infos Produit", "en": "Question Choose Product"},
                    "polarized": false
                }, {
                    "name": "topicOutOfStock",
                    "labels": {"fr": "Produit indisponible", "en": "Out of Stock"},
                    "polarized": false
                }, {
                    "name": "topicOutOfStockTest",
                    "labels": {"fr": "Produit indisponible TEST", "en": "Out of Stock"},
                    "polarized": false
                }, {
                    "name": "topicOpinionChoice",
                    "labels": {"fr": "Gamme", "en": "Product choice"},
                    "polarized": true
                }, {
                    "name": "topicProductQuality",
                    "labels": {"fr": "Qualité du Produit", "en": "Product Quality"},
                    "polarized": true
                }, {"name": "topicSample", "labels": {"fr": "Echantillons", "en": "Samples"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "commercialactivity",
                "labels": {"fr": "Activité commerciale", "en": "Commercial Activity"},
                "children": [{
                    "name": "topicEventSales",
                    "labels": {"fr": "Soldes", "en": "Sales"},
                    "polarized": false
                }, {
                    "name": "topicPrivateSales",
                    "labels": {"fr": "Ventes Privées", "en": "Private Sales"},
                    "polarized": false
                }, {
                    "name": "topicQuestionPromos",
                    "labels": {"fr": "Questions promos", "en": "Promos Questions"},
                    "polarized": false
                }, {
                    "name": "PromoCoupon",
                    "labels": {"fr": "Code Promo", "en": "Promo Coupon Bug"},
                    "polarized": false
                }, {
                    "name": "topicSpecialOfferForgotten",
                    "labels": {"fr": "Code Promo Oublié", "en": "Promo Coupon Forgotten"},
                    "polarized": false
                }, {
                    "name": "topicPromoOfferApplication",
                    "labels": {"fr": "Application promo", "en": "Promotional Offer Application"},
                    "polarized": false
                }, {
                    "name": "topicOpinionPromo",
                    "labels": {"fr": "Avis promos", "en": "Promo Opinions"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "loyaltyprogramme",
                "labels": {"fr": "Programme de fidelité", "en": "Loyalty Card"},
                "children": [{
                    "name": "topicMembershipProgramme",
                    "labels": {"fr": "Adhésion au programme", "en": "Membership Programme"},
                    "polarized": false
                }, {
                    "name": "CardOpinion",
                    "labels": {"fr": "Avis carte", "en": "Card Opinion"},
                    "polarized": false
                }, {
                    "name": "AccumulateLoyaltyPoints",
                    "labels": {"fr": "Cumuler pts fid", "en": "Accumulate Loyalty Points"},
                    "polarized": false
                }, {
                    "name": "topicLoyaltyProgrammOpinion",
                    "labels": {"fr": "Avis Programme Fid", "en": "Loyalty Programm"},
                    "polarized": true
                }, {
                    "name": "topicMembershipCard",
                    "labels": {"fr": "Adhésion carte", "en": "Membership Card"},
                    "polarized": false
                }, {
                    "name": "IssueCofinogaCard",
                    "labels": {"fr": "Pbs carte Cofinoga", "en": "Issue Cofinoga Card"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "website",
                "labels": {"fr": "Site web / Espace Client", "en": "Website / Customer Space"},
                "children": [{
                    "name": "topicErgonomicWebsite",
                    "labels": {"fr": "Ergonomie", "en": "Ergonomic"},
                    "polarized": true
                }, {
                    "name": "topicDesignWebsite",
                    "labels": {"fr": "Design", "en": "Design"},
                    "polarized": true
                }, {
                    "name": "topicProductDescriptionWebsite",
                    "labels": {"fr": "Description produits", "en": "Product Description"},
                    "polarized": true
                }, {
                    "name": "topicBugs",
                    "labels": {"fr": "Erreurs techniques", "en": "Bugs"},
                    "polarized": true
                }, {
                    "name": "topicGeneralOpinionWebsite",
                    "labels": {"fr": "Avis site", "en": "General Opinion"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "order",
                "labels": {"fr": "Passer Commande", "en": "Placing Order"},
                "children": [{
                    "name": "IntentToPlaceOrder",
                    "labels": {"fr": "Passer commande", "en": "Placing Order"},
                    "polarized": false
                }, {
                    "name": "topicPayment",
                    "labels": {"fr": "Payer ma commande", "en": "Payment Method Accepted"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "resa",
                "labels": {"fr": "E-réservation", "en": "EReservation"},
                "children": [{
                    "name": "topicQuestionBookingOrder",
                    "labels": {"fr": "Modalités E-réservation", "en": "Questions sur la réservation"},
                    "polarized": false
                }, {
                    "name": "topicIssueForBookingOrder",
                    "labels": {"fr": "Pb pour réserver", "en": "Pb pour réserver"},
                    "polarized": false
                }, {
                    "name": "topicOpinionBooking",
                    "labels": {"fr": "Avis E-réservation", "en": "topic Opinion Booking"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "afterorder",
                "labels": {"fr": "Après la commande", "en": "After the Order"},
                "children": [{
                    "name": "ModifyOrder",
                    "labels": {"fr": "Modifier ma Commande", "en": "Modify Order"},
                    "polarized": false
                }, {
                    "name": "IntentToCancelOrder",
                    "labels": {"fr": "Annuler ma commande", "en": "Cancel Order"},
                    "polarized": false
                }, {
                    "name": "InformationCancelOrderBrand",
                    "labels": {"fr": "Commande annulée", "en": "My order has been canceled"},
                    "polarized": false
                }, {
                    "name": "topicTrackingOrderInformations",
                    "labels": {"fr": "Suivre ma commande", "en": "Track Order Informations"},
                    "polarized": false
                }, {
                    "name": "topicExchangeOrder",
                    "labels": {"fr": "Echange commande", "en": "Exchange Order"},
                    "polarized": false
                }, {
                    "name": "IntentReturnOrder",
                    "labels": {"fr": "Retour commande", "en": "Return Order"},
                    "polarized": false
                }, {
                    "name": "topicRefundOrder",
                    "labels": {"fr": "Remboursement", "en": "Refund Order"},
                    "polarized": false
                }, {
                    "name": "IntentCollectOrder",
                    "labels": {"fr": "Retirer ma commande", "en": "Intent to collect order"},
                    "polarized": false
                }, {"name": "Invoice", "labels": {"fr": "Demande de facture", "en": "Invoice"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "deliveryinformations",
                "labels": {"fr": "Avant de me faire livrer", "en": "Delivery Informations"},
                "children": [{
                    "name": "topicOpinionDeliveryMode",
                    "labels": {"fr": "Mode de livraison", "en": "Delivery Method"},
                    "polarized": false
                }, {
                    "name": "topicOpinionDeliveryModeTest",
                    "labels": {"fr": "Mode de livraison TEST", "en": "Delivery Method"},
                    "polarized": false
                }, {
                    "name": "topicModifyShippingAddress",
                    "labels": {"fr": "Adresse de Livraison", "en": "Shipping Address"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "delivery",
                "labels": {"fr": "Suivi de livraison", "en": "Delivery"},
                "children": [{
                    "name": "LateDelivery",
                    "labels": {"fr": "Retard de Livraison", "en": "Late Delivery"},
                    "polarized": false
                }, {
                    "name": "topicOpinionDelivery",
                    "labels": {"fr": "Avis sur la Livraison", "en": "Opinion On Delivery"},
                    "polarized": true
                }, {
                    "name": "topicOpinionDeliveryTime",
                    "labels": {"fr": "Horaires de Livraison", "en": "Delivery Time"},
                    "polarized": true
                }, {
                    "name": "topicDeliveredToWrongPlace",
                    "labels": {"fr": "Erreur de Livraison", "en": "Delivery Time"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "receivedProduct",
                "labels": {"fr": "Je reçois ma commande", "en": "Received Product"},
                "children": [{
                    "name": "topicMissingProduct",
                    "labels": {"fr": "Produit Manquant", "en": "Missing Product"},
                    "polarized": false
                }, {
                    "name": "topicPackaging",
                    "labels": {"fr": "Colis", "en": "Packaging"},
                    "polarized": false
                }, {
                    "name": "Defective",
                    "labels": {"fr": "Produit défectueux", "en": "Defective Product"},
                    "polarized": false
                }, {
                    "name": "NonCompliant",
                    "labels": {"fr": "Conformité produit", "en": "Non Compliant Product"},
                    "polarized": false
                }, {
                    "name": "NonCompliantTEST",
                    "labels": {"fr": "Conformité produit", "en": "Non Compliant Product"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "beforevisitingstore",
                "labels": {"fr": "Mon magasin/Préparer ma visite", "en": "Visiting Store"},
                "children": [{
                    "name": "topicLocationStore",
                    "labels": {"fr": "Proximité", "en": "Location"},
                    "polarized": true
                }, {
                    "name": "topicTimeOpeningStore",
                    "labels": {"fr": "Horaires", "en": "Store Ppening Hours"},
                    "polarized": true
                }, {"name": "topicStoreParking", "labels": {"fr": "Parking", "en": "Parking"}, "polarized": true}],
                "polarized": false
            }, {
                "name": "instore",
                "labels": {"fr": "Expérience en magasin", "en": "In Store"},
                "children": [{
                    "name": "topicGenericStore",
                    "labels": {"fr": "Avis général", "en": "Generic Opinion Store"},
                    "polarized": true
                }, {
                    "name": "topicArrangementOfStore",
                    "labels": {"fr": "Aménagement", "en": "Arrangement Of Store"},
                    "polarized": true
                }, {
                    "name": "topicAmbianceOfStore",
                    "labels": {"fr": "Confort", "en": "Ambiance Of Store"},
                    "polarized": true
                }, {
                    "name": "topicStoreSignage",
                    "labels": {"fr": "Signalétique", "en": "Store signage"},
                    "polarized": true
                }, {
                    "name": "topicStoreServices",
                    "labels": {"fr": "Services", "en": "Store Services"},
                    "polarized": false
                }, {
                    "name": "topicWaitingStore",
                    "labels": {"fr": "Attente en magasin", "en": "Waiting in Store"},
                    "polarized": false
                }, {"name": "topicWaitingCheckout", "labels": {"fr": "Caisse", "en": "Checkout"}, "polarized": true}],
                "polarized": false
            }, {
                "name": "brandandproduct",
                "labels": {"fr": "Engagement", "en": "Engagement"},
                "children": [{
                    "name": "topicQualityOfService",
                    "labels": {"fr": "Qualité de service", "en": "Quality of Service"},
                    "polarized": true
                }, {
                    "name": "topicBrandRelationship",
                    "labels": {"fr": "Relation à la Marque", "en": "Brand Relationship"},
                    "polarized": true
                }, {
                    "name": "topicIRecommend",
                    "labels": {"fr": "Je recommande", "en": "I Recommend"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "customeraccount",
                "labels": {"fr": "Compte client", "en": "Customer Account"},
                "children": [{
                    "name": "CreateAccount",
                    "labels": {"fr": "Créer mon compte", "en": "Create Account"},
                    "polarized": false
                }, {
                    "name": "topicAccess",
                    "labels": {"fr": "Accéder à mon compte", "en": "Acces Account"},
                    "polarized": false
                }, {
                    "name": "topicCloseAccount",
                    "labels": {"fr": "Supprimer mon compte", "en": "Close Account"},
                    "polarized": false
                }, {
                    "name": "topicRegisterLoyaltyCard",
                    "labels": {"fr": "Enregistrer ma CF", "en": "Register Loyalty Card"},
                    "polarized": false
                }, {
                    "name": "IntentToModifyDetails",
                    "labels": {"fr": "Modifier mes coordonnées", "en": "Modify details"},
                    "polarized": false
                }, {"name": "topicOptIn", "labels": {"fr": "Abonnement/News", "en": "Opt-In"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "contact",
                "labels": {"fr": "Contacter le Service Client", "en": "Contact"},
                "children": [{
                    "name": "topicContactBrand",
                    "labels": {"fr": "Joignabilité", "en": "Contact GL"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "staff",
                "labels": {"fr": "Equipe", "en": "Staff"},
                "children": [{
                    "name": "topicAmability",
                    "labels": {"fr": "Amabilité", "en": "Amability"},
                    "polarized": true
                }, {
                    "name": "topicCompetency",
                    "labels": {"fr": "Compétence", "en": "Competency"},
                    "polarized": true
                }, {
                    "name": "topicAttentiveness",
                    "labels": {"fr": "Ecoute", "en": "Attentiveness"},
                    "polarized": true
                }, {
                    "name": "topicEfficiency",
                    "labels": {"fr": "Rapidité", "en": "Efficiency"},
                    "polarized": true
                }, {
                    "name": "topicDisponibility",
                    "labels": {"fr": "Disponibilité", "en": "Disponibility"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "nonactionable",
                "labels": {"fr": "Non Actionnables", "en": "Non Actionnable"},
                "children": [{
                    "name": "topicNonActionable",
                    "labels": {"fr": "Non Actionnables", "en": "Non Actionnable"},
                    "polarized": false
                }],
                "polarized": false
            }]
        },
        "enhancement.categories.emotion": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Emotions", "en": "Emotions"},
            "hierarchical": true,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 103},
                "dashboardFilterView": {"enabled": true, "order": 103},
                "feedbackDetailsView": {"enabled": true, "order": 103}
            },
            "values": [{
                "name": "satisfaction",
                "labels": {"fr": "Satisfaction", "en": "Satisfaction"},
                "children": [{
                    "name": "topicSatisfaction",
                    "labels": {"fr": "Satisfait", "en": "Satisfaction"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "anger",
                "labels": {"fr": "En colère", "en": "Anger"},
                "children": [{
                    "name": "topicAnger",
                    "labels": {"fr": "En Colère", "en": "Anger"},
                    "polarized": false
                }, {
                    "name": "topicEmbarrassment",
                    "labels": {"fr": "Embarrasé", "en": "Embarrassment"},
                    "polarized": false
                }, {"name": "topicShock", "labels": {"fr": "Choqué", "en": "Shock"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "fear",
                "labels": {"fr": "Peur", "en": "Fear"},
                "children": [{"name": "topicFear", "labels": {"fr": "Inquiet", "en": "Fear"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "sadness",
                "labels": {"fr": "Triste", "en": "Sadness"},
                "children": [{
                    "name": "topicSadness",
                    "labels": {"fr": "Triste", "en": "Sadness"},
                    "polarized": false
                }, {
                    "name": "topicDisappointment",
                    "labels": {"fr": "Déçu", "en": "Disappointment"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "dissatisfaction",
                "labels": {"fr": "Insatisfait", "en": "Dissatisfaction"},
                "children": [{
                    "name": "topicDissatisfaction",
                    "labels": {"fr": "Insatisfait", "en": "Dissatisfaction"},
                    "polarized": false
                }, {"name": "topicDoubt", "labels": {"fr": "Doute", "en": "Doubt"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "reaction",
                "labels": {"fr": "Réaction", "en": "Reaction"},
                "children": [{
                    "name": "topicSurprise",
                    "labels": {"fr": "Surpris", "en": "Surprise"},
                    "polarized": false
                }],
                "polarized": false
            }]
        },
        "enhancement.categories.risk": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Intentions de mes clients", "en": "Risks"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 104},
                "dashboardFilterView": {"enabled": true, "order": 104},
                "feedbackDetailsView": {"enabled": true, "order": 104}
            },
            "values": [{
                "name": "callCustomerService",
                "labels": {"fr": "Effort Client", "en": "Asking for recall"},
                "polarized": false
            }, {"name": "churn", "labels": {"fr": "Churn", "en": "Churn"}, "polarized": false}, {
                "name": "legal",
                "labels": {"fr": "Litige", "en": "Legal Risk"},
                "polarized": false
            }, {
                "name": "NotWarned",
                "labels": {"fr": "Non prévenu", "en": "Not warned"},
                "polarized": false
            }, {
                "name": "Fraud",
                "labels": {"fr": "Fraude", "en": "Fraud"},
                "polarized": false
            }, {
                "name": "riskReputation",
                "labels": {"fr": "Mauvaise Réputation", "en": "Reputation"},
                "polarized": false
            }, {
                "name": "UnkeptCommitment",
                "labels": {"fr": "Engagements non tenus", "en": "Unkept commitment"},
                "polarized": false
            }, {
                "name": "askingForRecall",
                "labels": {"fr": "Demandes de rappel", "en": "Recall"},
                "polarized": false
            }, {"name": "Harassment", "labels": {"fr": "Harcèlement", "en": "Harassment"}, "polarized": false}]
        },
        "enhancement.satisfaction": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Satisfaction Client", "en": "Sentiment"},
            "hierarchical": true,
            "exportable": true,
            "polarized": true,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 105},
                "dashboardFilterView": {"enabled": true, "order": 105},
                "feedbackDetailsView": {"enabled": false, "order": 105}
            },
            "values": [{
                "name": "negative",
                "labels": {"fr": "Négative", "en": "Negative"},
                "polarized": false
            }, {
                "name": "positive",
                "labels": {"fr": "Positive", "en": "Positive"},
                "polarized": false
            }, {"name": "mixed", "labels": {"fr": "Mitigé", "en": "Mixed"}, "polarized": false}, {
                "name": "neutral",
                "labels": {"fr": "Neutre", "en": "Neutral"},
                "polarized": false
            }]
        },
        "enhancement.categories.satisfaction": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Satisfaction Client", "en": "Sentiment"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 106},
                "dashboardFilterView": {"enabled": false, "order": 106},
                "feedbackDetailsView": {"enabled": true, "order": 106}
            },
            "values": [{
                "name": "negative",
                "labels": {"fr": "Négative", "en": "Negative"},
                "polarized": false
            }, {"name": "positive", "labels": {"fr": "Positive", "en": "Positive"}, "polarized": false}]
        },
        "enhancement.categories.tag": {
            "@version": "1",
            "enabled": false,
            "labels": {"fr": "Tags", "en": "Tags"},
            "hierarchical": true,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 105},
                "dashboardFilterView": {"enabled": true, "order": 105},
                "feedbackDetailsView": {"enabled": true, "order": 105}
            }
        },
        "enhancement.nps": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "NPS", "en": "NPS"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 108},
                "dashboardFilterView": {"enabled": true, "order": 108},
                "feedbackDetailsView": {"enabled": true, "order": 108}
            },
            "values": [{
                "name": "1",
                "labels": {"fr": "Promoteurs", "en": "Promoters"},
                "polarized": false
            }, {"name": "-1", "labels": {"fr": "Détracteurs", "en": "Detractors"}, "polarized": false}, {
                "name": "0",
                "labels": {"fr": "Passifs", "en": "Passives"},
                "polarized": false
            }]
        },
        "enhancement.computational.nps100": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "NPS", "en": "NPS"},
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.recommendationScore": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Score de recommandation", "en": "Recommendation score"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 202},
                "dashboardFilterView": {"enabled": false, "order": 202},
                "feedbackDetailsView": {"enabled": false, "order": 202}
            }
        },
        "metadata.custom.veckoFilename": {
            "@version": "1",
            "enabled": false,
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.month": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.subject": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "verbatim": {"@version": "1", "enabled": true, "hierarchical": false, "exportable": true, "polarized": false},
        "metadata.custom.place_name": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Magasin", "en": "Store"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 110},
                "dashboardFilterView": {"enabled": true, "order": 110},
                "feedbackDetailsView": {"enabled": true, "order": 110},
                "dynamicDashboardSelector": {"enabled": true, "order": 110},
                "topicsStatListView": {"enabled": true, "order": 10}
            }
        },
        "metadata.custom.place_levels_Regroupement_Bu": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Regroupement BU", "en": "BU"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 111},
                "dashboardFilterView": {"enabled": true, "order": 111},
                "feedbackDetailsView": {"enabled": true, "order": 111},
                "dynamicDashboardSelector": {"enabled": false, "order": 111}
            }
        },
        "metadata.custom.place_levels_Enseigne": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Enseigne", "en": "Company"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 111},
                "dashboardFilterView": {"enabled": true, "order": 111},
                "feedbackDetailsView": {"enabled": true, "order": 111},
                "dynamicDashboardSelector": {"enabled": false, "order": 111}
            }
        },
        "metadata.custom.place_levels_Canal": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Canal", "en": "Channel"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 111},
                "dashboardFilterView": {"enabled": true, "order": 111},
                "feedbackDetailsView": {"enabled": true, "order": 111},
                "dynamicDashboardSelector": {"enabled": false, "order": 111}
            }
        },
        "metadata.custom.context_cz_tag": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Parcours", "en": "Journey"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 112},
                "dashboardFilterView": {"enabled": true, "order": 112},
                "feedbackDetailsView": {"enabled": true, "order": 112}
            }
        },
        "metadata.custom.context_extra_order_type": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Type d'achat", "en": "Purchase Type"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 113},
                "dashboardFilterView": {"enabled": true, "order": 113},
                "feedbackDetailsView": {"enabled": true, "order": 113}
            }
        },
        "metadata.custom.context_extra_brand": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Marques", "en": "Brands"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 114},
                "dashboardFilterView": {"enabled": true, "order": 114},
                "feedbackDetailsView": {"enabled": true, "order": 114},
                "dynamicDashboardSelector": {"enabled": true, "order": 114}
            }
        },
        "metadata.custom.context_extra_fid": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Fidélité", "en": "Loyalty"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 115},
                "dashboardFilterView": {"enabled": true, "order": 115},
                "feedbackDetailsView": {"enabled": true, "order": 115}
            }
        },
        "metadata.custom.context_extra_statut_pqsta_fidgl": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Statut Fidélité", "en": "Loyalty Status"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 116},
                "dashboardFilterView": {"enabled": true, "order": 116},
                "feedbackDetailsView": {"enabled": true, "order": 116}
            }
        },
        "metadata.custom.conversation": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.idUser": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.lazy": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Paresseux", "en": "Lazy"},
            "hierarchical": false,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 1},
                "dashboardFilterView": {"enabled": false, "order": 1},
                "feedbackDetailsView": {"enabled": false, "order": 1}
            },
            "values": [{
                "name": "value1",
                "labels": {"fr": "valeur 1", "en": "value 1"},
                "polarized": false
            }, {"name": "value2", "labels": {"fr": "valeur 2", "en": "value 2"}, "polarized": false}]
        }
    },
    "fieldsValue": {
        "metadata.standard.channelName": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.place_name": [{"value": "BHV Marais"}, {"value": "GaleriesLafayette.com"}, {"value": "Galeries Lafayette HAUSSMANN"}, {"value": "Galeries Lafayette Maine Montparnasse"}, {"value": "BHV Parly 2"}, {"value": "Galeries Lafayette Toulouse Lapeyrouse"}, {"value": "Galeries Lafayette Nice Cap 3000"}, {"value": "Galeries Lafayette Lyon Bron"}, {"value": "Galeries Lafayette Bordeaux"}, {"value": "Galeries Lafayette Nice Massena"}, {"value": "Galeries Lafayette Strasbourg"}, {"value": "Galeries Lafayette Nantes Decre"}, {"value": "Galeries Lafayette Lyon Part Dieu"}, {"value": "Galeries Lafayette Marseille Bourse"}, {"value": "Galeries Lafayette Montpellier"}, {"value": "Galeries Lafayette Perpignan"}, {"value": "Galeries Lafayette Annecy"}, {"value": "Galeries Lafayette Avignon"}, {"value": "bhv.fr"}, {"value": "Galeries Lafayette Marseille Prado"}, {"value": "Galeries Lafayette Metz"}, {"value": "Galeries Lafayette Rennes"}, {"value": "Galeries Lafayette Rosny"}, {"value": "Galeries Lafayette Carre-Senart"}, {"value": "Galeries Lafayette Dijon"}, {"value": "Galeries Lafayette Grenoble"}, {"value": "Galeries Lafayette Orleans"}, {"value": "Galeries Lafayette Reims"}, {"value": "Galeries Lafayette Clermont Ferrand"}, {"value": "Galeries Lafayette Biarritz"}, {"value": "Galeries Lafayette Tours"}, {"value": "BHV Limonest"}, {"value": "Galeries Lafayette Caen"}, {"value": "Galeries Lafayette Bayonne"}, {"value": "Galeries Lafayette Angers"}, {"value": "Galeries Lafayette Rouen"}, {"value": "Galeries Lafayette Amiens"}, {"value": "Galeries Lafayette Besançon"}, {"value": "Galeries Lafayette Toulon"}, {"value": "Galeries Lafayette Le Mans"}, {"value": "Galeries Lafayette Limoges"}, {"value": "Galeries Lafayette La Rochelle"}, {"value": "Galeries Lafayette l'Outlet ONE NATION"}, {"value": "Galeries Lafayette Cannes"}, {"value": "Galeries Lafayette Lorient"}, {"value": "Galeries Lafayette Béziers"}, {"value": "Galeries Lafayette l'Outlet NAILLOUX"}, {"value": "Galeries Lafayette La Roche-sur-Yon"}, {"value": "Galeries Lafayette l'Outlet ROUBAIX"}, {"value": "Galeries Lafayette Beauvais"}, {"value": "Galeries Lafayette Montauban"}, {"value": "Galeries Lafayette Dax"}, {"value": "Galeries Lafayette l'Outlet THE VILLAGE"}, {"value": "Galeries Lafayette Tarbes"}, {"value": "Galeries Lafayette Belfort"}, {"value": "Galeries Lafayette Agen"}, {"value": "Galeries Lafayette Chalon-sur-Saône"}, {"value": "Galeries Lafayette l'Outlet HONFLEUR"}, {"value": "Galeries Lafayette l'Outlet LA SEGUINIERE"}, {"value": "Galeries Lafayette l'Outlet TALANGE"}, {"value": "Galeries Lafayette l'Outlet COQUELLES"}, {"value": "Galeries Lafayette Saintes"}, {"value": "Galeries Lafayette Pau"}, {"value": "BHV Part Dieu"}, {"value": "Galeries Lafayette Champs-Elysées"}, {"value": "Galeries Lafayette Chambéry"}, {"value": "Galeries Lafayette Niort"}, {"value": "Galeries Lafayette Langon"}, {"value": "Galeries Lafayette Angoulême"}, {"value": "Galeries Lafayette Libourne"}, {"value": "Galeries Lafayette Menton"}, {"value": "L'Usine Mode et Maison VELIZY"}, {"value": "Galeries Lafayette l'Outlet ROPPENHEIM"}, {"value": "Galeries Lafayette l’Outlet L’ÎLE SAINT-DENIS"}, {"value": "Eataly Paris Marais"}],
        "metadata.custom.place_levels_Regroupement_Bu": [{"value": "Réseau GL"}, {"value": "Magasins BHV"}, {"value": "GL.com"}, {"value": "Affiliés GL"}, {"value": "Haussmann"}, {"value": "Outlets"}, {"value": "bhv.fr"}, {"value": "Champs-Elysées"}],
        "metadata.custom.place_levels_Enseigne": [{"value": "Galeries Lafayette"}, {"value": "Le BHV"}, {"value": "Galeries Lafayette l'Outlet"}, {"value": "Eataly"}],
        "metadata.custom.place_levels_Canal": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_cz_tag": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_order_type": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_brand": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_fid": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_statut_pqsta_fidgl": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}]
    }
};

const exportedDashboard2 = {
    "filter": {"dateRange": {"start": "2020-11-30", "end": "2021-11-30", "zoneId": "Indian/Mauritius"}}, "dashboard": {
        "id": "manager",
        "data": {
            "hasData": true, "payload": {
                "mainSatScore": {
                    "value": 10,
                    "count": 4701,
                    "trend": -43,
                    "from": "2020-11-29T20:00:00.000Z",
                    "to": "2021-11-29T20:00:00.000Z",
                    "distribution": {"NEGATIVE": 4030, "POSITIVE": 571, "NEUTRAL": 100}
                },
                "refSatScore": {
                    "value": 14,
                    "count": 957,
                    "trend": -47,
                    "from": "2020-11-29T20:00:00.000Z",
                    "to": "2021-11-29T20:00:00.000Z",
                    "distribution": {"NEGATIVE": 707, "POSITIVE": 22, "NEUTRAL": 228}
                },
                "positiveTopicImpact": [{
                    "topic": "Amabilité",
                    "impact": 39,
                    "trend": -3,
                    "count": 4845
                }, {"topic": "Compétence", "impact": 45, "trend": -3, "count": 1284}, {
                    "topic": "Livraison",
                    "impact": 32,
                    "trend": 4,
                    "count": 2958
                }, {"topic": "Qualité", "impact": 42, "trend": 3, "count": 4482}, {
                    "topic": "Ergonomie",
                    "impact": 37,
                    "trend": 2,
                    "count": 2688
                }],
                "negativeTopicImpact": [{
                    "topic": "Amabilité",
                    "impact": -10,
                    "trend": 0,
                    "count": 1850
                }, {"topic": "Compétence", "impact": -2, "trend": -2, "count": 4835}, {
                    "topic": "Livraison",
                    "impact": -30,
                    "trend": 10,
                    "count": 986
                }, {"topic": "Qualité", "impact": -42, "trend": 10, "count": 333}, {
                    "topic": "Ergonomie",
                    "impact": -27,
                    "trend": 1,
                    "count": 2969
                }],
                "satEvolution": {
                    "series": ["main", "ref"],
                    "values": [{"date": "2019-01-01", "values": {"main": 64, "ref": 71}}, {
                        "date": "2019-02-01",
                        "values": {"main": -42, "ref": 22}
                    }, {"date": "2019-03-01", "values": {"main": 59, "ref": -33}}, {
                        "date": "2019-04-01",
                        "values": {"main": -88, "ref": 76}
                    }, {"date": "2019-05-01", "values": {"main": -91, "ref": 86}}, {
                        "date": "2019-06-01",
                        "values": {"main": 9, "ref": -73}
                    }, {"date": "2019-07-01", "values": {"main": 87, "ref": 68}}, {
                        "date": "2019-08-01",
                        "values": {"main": 74, "ref": 6}
                    }, {"date": "2019-09-01", "values": {"main": 75, "ref": -50}}, {
                        "date": "2019-10-01",
                        "values": {"main": -61, "ref": 17}
                    }, {"date": "2019-11-01", "values": {"main": 9, "ref": -34}}, {
                        "date": "2019-12-01",
                        "values": {"main": -49, "ref": 64}
                    }, {"date": "2020-01-01", "values": {"main": 32, "ref": 41}}]
                },
                "positiveTopicImpactTopEvolution": [{
                    "topic": "Livraison", "value": 11.5, "trend": 2.1, "feedback": {
                        "verbatims": [{
                            "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                            "offsets": [{
                                "tree": "topic",
                                "start": 114,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "instore/topicGenericStore"
                            }, {
                                "tree": "emotion",
                                "start": 129,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 15,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 95}, {
                                "ordinal": 2,
                                "start": 95,
                                "end": 154
                            }, {"ordinal": 3, "start": 154, "end": 179}]
                        }],
                        "enhancement": {
                            "satisfaction": "NEGATIVE",
                            "categories": {
                                "topic": ["instore/topicGenericStore"],
                                "satisfaction": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "pzPFOgxquv"
                            }
                        },
                        "date": 1638282097588,
                        "satMood": "POSITIVE",
                        "satScore": 0,
                        "satType": "NPS",
                        "id": 0
                    }
                }, {
                    "topic": "Qualité", "value": -14.2, "trend": 3.2, "feedback": {
                        "verbatims": [{
                            "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                            "offsets": [{
                                "tree": "topic",
                                "start": 114,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "instore/topicGenericStore"
                            }, {
                                "tree": "emotion",
                                "start": 129,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 15,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 95}, {
                                "ordinal": 2,
                                "start": 95,
                                "end": 154
                            }, {"ordinal": 3, "start": 154, "end": 179}]
                        }],
                        "enhancement": {
                            "satisfaction": "NEGATIVE",
                            "categories": {
                                "topic": ["instore/topicGenericStore"],
                                "satisfaction": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "oyoRiYTFMi"
                            }
                        },
                        "date": 1638282097588,
                        "satMood": "POSITIVE",
                        "satScore": 8,
                        "satType": "NPS",
                        "id": 0
                    }
                }, {
                    "topic": "Ergonomie", "value": 14.6, "trend": 9.3, "feedback": {
                        "verbatims": [{
                            "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                            "offsets": [{
                                "tree": "topic",
                                "start": 114,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "instore/topicGenericStore"
                            }, {
                                "tree": "emotion",
                                "start": 129,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 15,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 95}, {
                                "ordinal": 2,
                                "start": 95,
                                "end": 154
                            }, {"ordinal": 3, "start": 154, "end": 179}]
                        }],
                        "enhancement": {
                            "satisfaction": "NEGATIVE",
                            "categories": {
                                "topic": ["instore/topicGenericStore"],
                                "satisfaction": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "QiIYU4V7x4"
                            }
                        },
                        "date": 1638282097589,
                        "satMood": "POSITIVE",
                        "satScore": 6,
                        "satType": "NPS",
                        "id": 0
                    }
                }],
                "negativeTopicImpactTopEvolution": [{
                    "topic": "Amabilité", "value": -8.5, "trend": -3.3, "feedback": {
                        "verbatims": [{
                            "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                            "offsets": [{
                                "tree": "topic",
                                "start": 114,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "instore/topicGenericStore"
                            }, {
                                "tree": "emotion",
                                "start": 129,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 15,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 95}, {
                                "ordinal": 2,
                                "start": 95,
                                "end": 154
                            }, {"ordinal": 3, "start": 154, "end": 179}]
                        }],
                        "enhancement": {
                            "satisfaction": "NEGATIVE",
                            "categories": {
                                "topic": ["instore/topicGenericStore"],
                                "satisfaction": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "6C78VXSOvO"
                            }
                        },
                        "date": 1638282097589,
                        "satMood": "NEGATIVE",
                        "satScore": 2,
                        "satType": "NPS",
                        "id": 0
                    }
                }, {
                    "topic": "Compétence", "value": -13.7, "trend": -3.4, "feedback": {
                        "verbatims": [{
                            "content": "Personnellement je trouve que les caisses automatiques ne vont pas avec le cadre du magasin.\n\nPour le reste c'est un magasin que j'apprécie énormément.\n\nBien à vous, \nMme N###1  ",
                            "offsets": [{
                                "tree": "topic",
                                "start": 114,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "instore/topicGenericStore"
                            }, {
                                "tree": "emotion",
                                "start": 129,
                                "end": 150,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 15,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 95}, {
                                "ordinal": 2,
                                "start": 95,
                                "end": 154
                            }, {"ordinal": 3, "start": 154, "end": 179}]
                        }],
                        "enhancement": {
                            "satisfaction": "NEGATIVE",
                            "categories": {
                                "topic": ["instore/topicGenericStore"],
                                "satisfaction": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "JNK1asWCeK"
                            }
                        },
                        "date": 1638282097589,
                        "satMood": "NEGATIVE",
                        "satScore": 8,
                        "satType": "NPS",
                        "id": 0
                    }
                }, {
                    "topic": "Livraison", "value": 6, "trend": -9.4, "feedback": {
                        "verbatims": [{
                            "content": "Bonjour, je tiens à remercier chaleureusement une de vos vendeuses appelée \" F#####1 \". C'est une jeune fille remarquable. Elle est très compétente, possède un sens du contact incroyable. Pleine d'empathie, elle est au service du client. J'ai été très agréablement surprise d'avoir été conseillée par une aussi jeune fille. Étant assez exigeante, elle a su me guider pour des achats de naissance qui étaient imprévus à la base. Elle s'est occupée de moi de À à Z alors qu'elle devait partir déjeuner. Elle m'a emmené également dans d'autres rayons que le sien. Elle a pensé au chiffre d'affaires des Galeries et pas seulement de son rayon. Elle est très à l'écoute des besoins et cible exactement ce dont on a besoin. C'est une vraie perle. Surtout conservez-la bien car je pense que je retournerai dans votre boutique plus tôt que prévu 😜. Dites lui encore mille mercis de ma part. \nBien cordialement.\nF##########2 N#####1 \n",
                            "offsets": [{
                                "tree": "topic",
                                "start": 216,
                                "end": 236,
                                "tonality": "POSITIVE",
                                "category": "brandandproduct/topicQualityOfService"
                            }, {
                                "tree": "topic",
                                "start": 640,
                                "end": 676,
                                "tonality": "POSITIVE",
                                "category": "staff/topicAttentiveness"
                            }, {
                                "tree": "topic",
                                "start": 160,
                                "end": 175,
                                "tonality": "NEUTRAL",
                                "category": "staff/topicAmability"
                            }, {
                                "tree": "emotion",
                                "start": 247,
                                "end": 264,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }, {
                                "tree": "emotion",
                                "start": 0,
                                "end": 7,
                                "tonality": "POSITIVE",
                                "category": "satisfaction/topicSatisfaction"
                            }],
                            "sentences": [{"ordinal": 1, "start": 0, "end": 89}, {
                                "ordinal": 2,
                                "start": 89,
                                "end": 124
                            }, {"ordinal": 3, "start": 124, "end": 189}, {
                                "ordinal": 4,
                                "start": 189,
                                "end": 239
                            }, {"ordinal": 5, "start": 189, "end": 239}, {
                                "ordinal": 6,
                                "start": 239,
                                "end": 325
                            }, {"ordinal": 7, "start": 325, "end": 429}, {
                                "ordinal": 8,
                                "start": 429,
                                "end": 502
                            }, {"ordinal": 9, "start": 502, "end": 562}, {
                                "ordinal": 10,
                                "start": 562,
                                "end": 641
                            }, {"ordinal": 11, "start": 641, "end": 719}, {
                                "ordinal": 12,
                                "start": 719,
                                "end": 742
                            }, {"ordinal": 13, "start": 742, "end": 842}, {
                                "ordinal": 14,
                                "start": 842,
                                "end": 885
                            }, {"ordinal": 15, "start": 885, "end": 904}, {"ordinal": 16, "start": 904, "end": 926}]
                        }],
                        "enhancement": {
                            "satisfaction": "MIXED",
                            "categories": {
                                "topic": ["brandandproduct/topicQualityOfService", "staff/topicAttentiveness", "staff/topicAmability"],
                                "emotion": ["satisfaction/topicSatisfaction"]
                            }
                        },
                        "metadata": {
                            "standard": {
                                "channelKind": "survey",
                                "channelName": "critizer",
                                "locale": "fr_FR"
                            },
                            "custom": {
                                "place_name": "Paris",
                                "place_levels_Regroupement_Bu": "Ile de France",
                                "place_levels_Enseigne": "BHV",
                                "context_extra_fid": "rkGzMTzDOF"
                            }
                        },
                        "date": 1638282097590,
                        "satMood": "NEGATIVE",
                        "satScore": 10,
                        "satType": "NPS",
                        "id": 0
                    }
                }],
                "actionList": [],
                "customersToRecall": {
                    "enhancement.categories.risk/churn": 99,
                    "enhancement.categories.risk/UnkeptCommitment": 94,
                    "enhancement.categories.risk/NotWarned": 4,
                    "enhancement.categories.risk/callCustomerService": 46
                },
                "mainRanking": [{
                    "category": "pricingpolicy/topicPricing",
                    "values": {
                        "SAT_SCORE": 81,
                        "VOLUME": 548,
                        "TREND": -10,
                        "POSITIVE_OPINIONS": 44,
                        "NEGATIVE_OPINIONS": 14
                    },
                    "rank": 1,
                    "highlighted": false
                }, {
                    "category": "pricingpolicy/topicShippingCost",
                    "values": {
                        "SAT_SCORE": 45,
                        "VOLUME": 60,
                        "TREND": -8,
                        "POSITIVE_OPINIONS": 3,
                        "NEGATIVE_OPINIONS": 48
                    },
                    "rank": 2,
                    "highlighted": false
                }, {
                    "category": "pricingpolicy/topicShippingCostTest",
                    "values": {
                        "SAT_SCORE": 75,
                        "VOLUME": 446,
                        "TREND": 7,
                        "POSITIVE_OPINIONS": 14,
                        "NEGATIVE_OPINIONS": 40
                    },
                    "rank": 3,
                    "highlighted": false
                }, {
                    "category": "offer/topicQuestionAboutAvailablity",
                    "values": {
                        "SAT_SCORE": 52,
                        "VOLUME": 679,
                        "TREND": -1,
                        "POSITIVE_OPINIONS": 45,
                        "NEGATIVE_OPINIONS": 12
                    },
                    "rank": 4,
                    "highlighted": false
                }, {
                    "category": "offer/topicQuestionChooseProduct",
                    "values": {
                        "SAT_SCORE": -71,
                        "VOLUME": 702,
                        "TREND": 2,
                        "POSITIVE_OPINIONS": 26,
                        "NEGATIVE_OPINIONS": 12
                    },
                    "rank": 5,
                    "highlighted": false
                }],
                "refRanking": [{
                    "category": "Galeries Lafayette",
                    "values": {
                        "SAT_SCORE": 91,
                        "VOLUME": 331,
                        "TREND": -10,
                        "POSITIVE_OPINIONS": 13,
                        "NEGATIVE_OPINIONS": 39
                    },
                    "rank": 1,
                    "highlighted": false
                }, {
                    "category": "Le BHV",
                    "values": {
                        "SAT_SCORE": -37,
                        "VOLUME": 164,
                        "TREND": 10,
                        "POSITIVE_OPINIONS": 42,
                        "NEGATIVE_OPINIONS": 19
                    },
                    "rank": 2,
                    "highlighted": false
                }, {
                    "category": "Galeries Lafayette l'Outlet",
                    "values": {
                        "SAT_SCORE": -93,
                        "VOLUME": 139,
                        "TREND": 0,
                        "POSITIVE_OPINIONS": 28,
                        "NEGATIVE_OPINIONS": 7
                    },
                    "rank": 3,
                    "highlighted": false
                }, {
                    "category": "Eataly",
                    "values": {
                        "SAT_SCORE": 53,
                        "VOLUME": 560,
                        "TREND": -3,
                        "POSITIVE_OPINIONS": 36,
                        "NEGATIVE_OPINIONS": 13
                    },
                    "rank": 4,
                    "highlighted": true
                }]
            }
        },
        "resolvedParams": {
            "satType": {"@type": "satType", "name": "NPS"},
            "main": {
                "@type": "fieldValue",
                "field": {"@type": "field", "name": "enhancement.categories.topic"},
                "value": ["pricingpolicy"]
            },
            "ref": {
                "@type": "fieldValue",
                "field": {"@type": "field", "name": "metadata.custom.place_levels_Enseigne"},
                "value": "Eataly"
            }
        },
        "config": {
            "id": "manager",
            "labels": {"fr": "Directeur", "en": "Manager"},
            "metric": "satType",
            "parameters": [{
                "@type": "selector",
                "name": "satType",
                "values": {
                    "@type": "list",
                    "items": [{"@type": "satType", "name": "NPS"}, {"@type": "satType", "name": "CSAT10"}]
                }
            }, {
                "@type": "fieldAndValueSelector",
                "name": "main",
                "labels": {"fr": "mon label", "en": "my label"},
                "allowMultiSelection": true,
                "fields": {
                    "@type": "list",
                    "items": [{"@type": "field", "name": "enhancement.categories.topic"}, {
                        "@type": "field",
                        "name": "metadata.custom.place_levels_Regroupement_Bu"
                    }, {"@type": "field", "name": "metadata.custom.place_name"}]
                }
            }, {
                "@type": "fieldAndValueSelector",
                "name": "ref",
                "fields": {
                    "@type": "switch",
                    "cases": [{
                        "condition": {
                            "@type": "paramMatch",
                            "param": "main.field",
                            "value": "enhancement.categories.topic"
                        },
                        "returns": {
                            "@type": "list",
                            "items": [{"@type": "field", "name": "metadata.custom.place_levels_Enseigne"}]
                        }
                    }, {
                        "condition": {
                            "@type": "paramMatch",
                            "param": "main.field",
                            "value": "metadata.custom.place_levels_Regroupement_Bu"
                        },
                        "returns": {
                            "@type": "list",
                            "items": [{
                                "@type": "field",
                                "name": "metadata.custom.place_levels_Regroupement_Bu"
                            }, {"@type": "field", "name": "metadata.custom.place_levels_Enseigne"}]
                        }
                    }, {
                        "condition": {
                            "@type": "paramMatch",
                            "param": "main.field",
                            "value": "metadata.custom.place_name"
                        },
                        "returns": {
                            "@type": "list",
                            "items": [{
                                "@type": "field",
                                "name": "metadata.custom.place_levels_Regroupement_Bu"
                            }, {"@type": "field", "name": "metadata.custom.place_levels_Enseigne"}]
                        }
                    }]
                }
            }],
            "visualizations": [{
                "id": "mainSatScore",
                "@type": "SAT_SCORE",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"}
                },
                "uiParams": {"distribution": {"enabled": true, "showNeutral": false}},
                "layout": {"page": 0, "x": 0, "y": 0, "w": 9, "h": 16}
            }, {
                "id": "refSatScore",
                "@type": "SAT_SCORE",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "term", "field": "${ref.field}", "term": "${ref.value}"}
                },
                "uiParams": {"arcOpacity": 0.35, "valueStyle": {"fontWeight": "normal"}},
                "layout": {"page": 0, "x": 9, "y": 0, "w": 9, "h": 16}
            }, {
                "id": "positiveTopicImpact",
                "@type": "TOPIC_IMPACT",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"},
                    "polarity": "POSITIVE",
                    "count": 5
                },
                "layout": {"page": 0, "x": 18, "y": 0, "w": 15, "h": 16}
            }, {
                "id": "negativeTopicImpact",
                "@type": "TOPIC_IMPACT",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"},
                    "polarity": "NEGATIVE",
                    "count": 5
                },
                "layout": {"page": 0, "x": 33, "y": 0, "w": 15, "h": 16}
            }, {
                "id": "satEvolution",
                "@type": "SAT_EVOLUTION",
                "params": {
                    "satType": "${satType}",
                    "series": [{
                        "name": "main",
                        "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"}
                    }, {
                        "name": "ref",
                        "constraint": {"@type": "term", "field": "${ref.field}", "term": "${ref.value}"}
                    }],
                    "interval": "month"
                },
                "uiParams": {"series": {"main": {"color": "#00b496"}, "ref": {"color": "#8A9BA8"}}},
                "layout": {"page": 0, "x": 0, "y": 16, "w": 18, "h": 19}
            }, {
                "id": "positiveTopicImpactTopEvolution",
                "@type": "TOPIC_IMPACT_TOP_EVOLUTION",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"},
                    "polarity": "POSITIVE",
                    "count": 3
                },
                "layout": {"page": 0, "x": 18, "y": 16, "w": 30, "h": 14}
            }, {
                "id": "negativeTopicImpactTopEvolution",
                "@type": "TOPIC_IMPACT_TOP_EVOLUTION",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"},
                    "polarity": "NEGATIVE",
                    "count": 3
                },
                "layout": {"page": 0, "x": 18, "y": 30, "w": 30, "h": 14}
            }, {
                "id": "actionList",
                "@type": "ACTION_LIST",
                "uiParams": {"theme": {"dark": true}},
                "layout": {"page": 0, "x": 0, "y": 25, "w": 18, "h": 9}
            }, {
                "id": "customersToRecall",
                "@type": "CUSTOMERS_TO_RECALL",
                "params": {
                    "constraint": {"@type": "terms", "field": "${main.field}", "terms": "${main.value}"},
                    "items": {
                        "enhancement.categories.risk/churn": {
                            "constraint": {
                                "@type": "term",
                                "field": "enhancement.categories.risk",
                                "term": "churn"
                            }
                        },
                        "enhancement.categories.risk/UnkeptCommitment": {
                            "constraint": {
                                "@type": "term",
                                "field": "enhancement.categories.risk",
                                "term": "UnkeptCommitment"
                            }
                        },
                        "enhancement.categories.risk/NotWarned": {
                            "constraint": {
                                "@type": "term",
                                "field": "enhancement.categories.risk",
                                "term": "NotWarned"
                            }
                        },
                        "enhancement.categories.risk/callCustomerService": {
                            "constraint": {
                                "@type": "term",
                                "field": "enhancement.categories.risk",
                                "term": "callCustomerService"
                            }
                        }
                    }
                },
                "layout": {"page": 1, "x": 0, "y": 0, "w": 18, "h": 30}
            }, {
                "id": "mainRanking",
                "@type": "RANKING",
                "params": {
                    "satType": "${satType}",
                    "constraint": {"@type": "terms", "field": "${ref.field}", "terms": "${ref.value}"},
                    "field": "${main.field}",
                    "highlight": "${main.value}",
                    "count": 5
                },
                "layout": {"page": 1, "x": 18, "y": 0, "w": 16, "h": 49}
            }, {
                "id": "refRanking",
                "@type": "RANKING",
                "params": {
                    "satType": "${satType}",
                    "field": "${ref.field}",
                    "highlight": ["${ref.value}"],
                    "count": 20
                },
                "layout": {"page": 1, "x": 34, "y": 0, "w": 14, "h": 49}
            }]
        }
    }, "dashboardVizEditor": {"validatedData": {}},
    "fields": {
        "date": {"@version": "1", "enabled": true, "hierarchical": false, "exportable": true, "polarized": false},
        "metadata.standard.channelKind": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Canal", "en": "Channel"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 1},
                "dashboardFilterView": {"enabled": true, "order": 1},
                "feedbackDetailsView": {"enabled": false, "order": 1},
                "topicsStatListView": {"enabled": false, "order": 2},
                "feedbacksListView": {"enabled": true, "order": 1}
            },
            "values": [{
                "name": "survey",
                "labels": {"fr": "Avis Client", "en": "Critizr Reviews"},
                "polarized": false
            }, {"name": "email", "labels": {"fr": "Emails", "en": "Emails"}, "polarized": false}, {
                "name": "chat",
                "labels": {"fr": "Chat Communautaire", "en": "Chat"},
                "polarized": false
            }]
        },
        "metadata.standard.channelName": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Sous Canal", "en": "Channel Name"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 2},
                "dashboardFilterView": {"enabled": true, "order": 2},
                "feedbackDetailsView": {"enabled": true, "order": 2}
            }
        },
        "metadata.standard.locale": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Langue", "en": "Locale"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 3},
                "feedbackDetailsView": {"enabled": false, "order": 3}
            },
            "values": [{
                "name": "en_GB",
                "labels": {"fr": "Anglais", "en": "English"},
                "polarized": false
            }, {"name": "fr_FR", "labels": {"fr": "Français", "en": "French"}, "polarized": false}]
        },
        "enhancement.categories.topic": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Ce que disent mes clients", "en": "Topics"},
            "hierarchical": true,
            "exportable": true,
            "polarized": true,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 102},
                "dashboardFilterView": {"enabled": false, "order": 102},
                "feedbackDetailsView": {"enabled": false, "order": 102},
                "topicsStatListView": {"enabled": false, "order": 3},
                "feedbacksListView": {"enabled": false, "order": 2}
            },
            "values": [{
                "name": "pricingpolicy",
                "labels": {"fr": "Politique tarifaire", "en": "Pricing Policy"},
                "children": [{
                    "name": "topicPricing",
                    "labels": {"fr": "Prix", "en": "Pricing"},
                    "polarized": true
                }, {
                    "name": "topicShippingCost",
                    "labels": {"fr": "Frais de livraison", "en": "ShippingCost"},
                    "polarized": true
                }, {
                    "name": "topicShippingCostTest",
                    "labels": {"fr": "Frais de livraison TEST", "en": "ShippingCost"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "offer",
                "labels": {"fr": "Offre", "en": "Commercial Offer"},
                "children": [{
                    "name": "topicQuestionAboutAvailablity",
                    "labels": {"fr": "Dispo produits", "en": "Availablity"},
                    "polarized": false
                }, {
                    "name": "topicQuestionChooseProduct",
                    "labels": {"fr": "Infos Produit", "en": "Question Choose Product"},
                    "polarized": false
                }, {
                    "name": "topicOutOfStock",
                    "labels": {"fr": "Produit indisponible", "en": "Out of Stock"},
                    "polarized": false
                }, {
                    "name": "topicOutOfStockTest",
                    "labels": {"fr": "Produit indisponible TEST", "en": "Out of Stock"},
                    "polarized": false
                }, {
                    "name": "topicOpinionChoice",
                    "labels": {"fr": "Gamme", "en": "Product choice"},
                    "polarized": true
                }, {
                    "name": "topicProductQuality",
                    "labels": {"fr": "Qualité du Produit", "en": "Product Quality"},
                    "polarized": true
                }, {"name": "topicSample", "labels": {"fr": "Echantillons", "en": "Samples"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "commercialactivity",
                "labels": {"fr": "Activité commerciale", "en": "Commercial Activity"},
                "children": [{
                    "name": "topicEventSales",
                    "labels": {"fr": "Soldes", "en": "Sales"},
                    "polarized": false
                }, {
                    "name": "topicPrivateSales",
                    "labels": {"fr": "Ventes Privées", "en": "Private Sales"},
                    "polarized": false
                }, {
                    "name": "topicQuestionPromos",
                    "labels": {"fr": "Questions promos", "en": "Promos Questions"},
                    "polarized": false
                }, {
                    "name": "PromoCoupon",
                    "labels": {"fr": "Code Promo", "en": "Promo Coupon Bug"},
                    "polarized": false
                }, {
                    "name": "topicSpecialOfferForgotten",
                    "labels": {"fr": "Code Promo Oublié", "en": "Promo Coupon Forgotten"},
                    "polarized": false
                }, {
                    "name": "topicPromoOfferApplication",
                    "labels": {"fr": "Application promo", "en": "Promotional Offer Application"},
                    "polarized": false
                }, {
                    "name": "topicOpinionPromo",
                    "labels": {"fr": "Avis promos", "en": "Promo Opinions"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "loyaltyprogramme",
                "labels": {"fr": "Programme de fidelité", "en": "Loyalty Card"},
                "children": [{
                    "name": "topicMembershipProgramme",
                    "labels": {"fr": "Adhésion au programme", "en": "Membership Programme"},
                    "polarized": false
                }, {
                    "name": "CardOpinion",
                    "labels": {"fr": "Avis carte", "en": "Card Opinion"},
                    "polarized": false
                }, {
                    "name": "AccumulateLoyaltyPoints",
                    "labels": {"fr": "Cumuler pts fid", "en": "Accumulate Loyalty Points"},
                    "polarized": false
                }, {
                    "name": "topicLoyaltyProgrammOpinion",
                    "labels": {"fr": "Avis Programme Fid", "en": "Loyalty Programm"},
                    "polarized": true
                }, {
                    "name": "topicMembershipCard",
                    "labels": {"fr": "Adhésion carte", "en": "Membership Card"},
                    "polarized": false
                }, {
                    "name": "IssueCofinogaCard",
                    "labels": {"fr": "Pbs carte Cofinoga", "en": "Issue Cofinoga Card"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "website",
                "labels": {"fr": "Site web / Espace Client", "en": "Website / Customer Space"},
                "children": [{
                    "name": "topicErgonomicWebsite",
                    "labels": {"fr": "Ergonomie", "en": "Ergonomic"},
                    "polarized": true
                }, {
                    "name": "topicDesignWebsite",
                    "labels": {"fr": "Design", "en": "Design"},
                    "polarized": true
                }, {
                    "name": "topicProductDescriptionWebsite",
                    "labels": {"fr": "Description produits", "en": "Product Description"},
                    "polarized": true
                }, {
                    "name": "topicBugs",
                    "labels": {"fr": "Erreurs techniques", "en": "Bugs"},
                    "polarized": true
                }, {
                    "name": "topicGeneralOpinionWebsite",
                    "labels": {"fr": "Avis site", "en": "General Opinion"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "order",
                "labels": {"fr": "Passer Commande", "en": "Placing Order"},
                "children": [{
                    "name": "IntentToPlaceOrder",
                    "labels": {"fr": "Passer commande", "en": "Placing Order"},
                    "polarized": false
                }, {
                    "name": "topicPayment",
                    "labels": {"fr": "Payer ma commande", "en": "Payment Method Accepted"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "resa",
                "labels": {"fr": "E-réservation", "en": "EReservation"},
                "children": [{
                    "name": "topicQuestionBookingOrder",
                    "labels": {"fr": "Modalités E-réservation", "en": "Questions sur la réservation"},
                    "polarized": false
                }, {
                    "name": "topicIssueForBookingOrder",
                    "labels": {"fr": "Pb pour réserver", "en": "Pb pour réserver"},
                    "polarized": false
                }, {
                    "name": "topicOpinionBooking",
                    "labels": {"fr": "Avis E-réservation", "en": "topic Opinion Booking"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "afterorder",
                "labels": {"fr": "Après la commande", "en": "After the Order"},
                "children": [{
                    "name": "ModifyOrder",
                    "labels": {"fr": "Modifier ma Commande", "en": "Modify Order"},
                    "polarized": false
                }, {
                    "name": "IntentToCancelOrder",
                    "labels": {"fr": "Annuler ma commande", "en": "Cancel Order"},
                    "polarized": false
                }, {
                    "name": "InformationCancelOrderBrand",
                    "labels": {"fr": "Commande annulée", "en": "My order has been canceled"},
                    "polarized": false
                }, {
                    "name": "topicTrackingOrderInformations",
                    "labels": {"fr": "Suivre ma commande", "en": "Track Order Informations"},
                    "polarized": false
                }, {
                    "name": "topicExchangeOrder",
                    "labels": {"fr": "Echange commande", "en": "Exchange Order"},
                    "polarized": false
                }, {
                    "name": "IntentReturnOrder",
                    "labels": {"fr": "Retour commande", "en": "Return Order"},
                    "polarized": false
                }, {
                    "name": "topicRefundOrder",
                    "labels": {"fr": "Remboursement", "en": "Refund Order"},
                    "polarized": false
                }, {
                    "name": "IntentCollectOrder",
                    "labels": {"fr": "Retirer ma commande", "en": "Intent to collect order"},
                    "polarized": false
                }, {"name": "Invoice", "labels": {"fr": "Demande de facture", "en": "Invoice"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "deliveryinformations",
                "labels": {"fr": "Avant de me faire livrer", "en": "Delivery Informations"},
                "children": [{
                    "name": "topicOpinionDeliveryMode",
                    "labels": {"fr": "Mode de livraison", "en": "Delivery Method"},
                    "polarized": false
                }, {
                    "name": "topicOpinionDeliveryModeTest",
                    "labels": {"fr": "Mode de livraison TEST", "en": "Delivery Method"},
                    "polarized": false
                }, {
                    "name": "topicModifyShippingAddress",
                    "labels": {"fr": "Adresse de Livraison", "en": "Shipping Address"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "delivery",
                "labels": {"fr": "Suivi de livraison", "en": "Delivery"},
                "children": [{
                    "name": "LateDelivery",
                    "labels": {"fr": "Retard de Livraison", "en": "Late Delivery"},
                    "polarized": false
                }, {
                    "name": "topicOpinionDelivery",
                    "labels": {"fr": "Avis sur la Livraison", "en": "Opinion On Delivery"},
                    "polarized": true
                }, {
                    "name": "topicOpinionDeliveryTime",
                    "labels": {"fr": "Horaires de Livraison", "en": "Delivery Time"},
                    "polarized": true
                }, {
                    "name": "topicDeliveredToWrongPlace",
                    "labels": {"fr": "Erreur de Livraison", "en": "Delivery Time"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "receivedProduct",
                "labels": {"fr": "Je reçois ma commande", "en": "Received Product"},
                "children": [{
                    "name": "topicMissingProduct",
                    "labels": {"fr": "Produit Manquant", "en": "Missing Product"},
                    "polarized": false
                }, {
                    "name": "topicPackaging",
                    "labels": {"fr": "Colis", "en": "Packaging"},
                    "polarized": false
                }, {
                    "name": "Defective",
                    "labels": {"fr": "Produit défectueux", "en": "Defective Product"},
                    "polarized": false
                }, {
                    "name": "NonCompliant",
                    "labels": {"fr": "Conformité produit", "en": "Non Compliant Product"},
                    "polarized": false
                }, {
                    "name": "NonCompliantTEST",
                    "labels": {"fr": "Conformité produit", "en": "Non Compliant Product"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "beforevisitingstore",
                "labels": {"fr": "Mon magasin/Préparer ma visite", "en": "Visiting Store"},
                "children": [{
                    "name": "topicLocationStore",
                    "labels": {"fr": "Proximité", "en": "Location"},
                    "polarized": true
                }, {
                    "name": "topicTimeOpeningStore",
                    "labels": {"fr": "Horaires", "en": "Store Ppening Hours"},
                    "polarized": true
                }, {"name": "topicStoreParking", "labels": {"fr": "Parking", "en": "Parking"}, "polarized": true}],
                "polarized": false
            }, {
                "name": "instore",
                "labels": {"fr": "Expérience en magasin", "en": "In Store"},
                "children": [{
                    "name": "topicGenericStore",
                    "labels": {"fr": "Avis général", "en": "Generic Opinion Store"},
                    "polarized": true
                }, {
                    "name": "topicArrangementOfStore",
                    "labels": {"fr": "Aménagement", "en": "Arrangement Of Store"},
                    "polarized": true
                }, {
                    "name": "topicAmbianceOfStore",
                    "labels": {"fr": "Confort", "en": "Ambiance Of Store"},
                    "polarized": true
                }, {
                    "name": "topicStoreSignage",
                    "labels": {"fr": "Signalétique", "en": "Store signage"},
                    "polarized": true
                }, {
                    "name": "topicStoreServices",
                    "labels": {"fr": "Services", "en": "Store Services"},
                    "polarized": false
                }, {
                    "name": "topicWaitingStore",
                    "labels": {"fr": "Attente en magasin", "en": "Waiting in Store"},
                    "polarized": false
                }, {"name": "topicWaitingCheckout", "labels": {"fr": "Caisse", "en": "Checkout"}, "polarized": true}],
                "polarized": false
            }, {
                "name": "brandandproduct",
                "labels": {"fr": "Engagement", "en": "Engagement"},
                "children": [{
                    "name": "topicQualityOfService",
                    "labels": {"fr": "Qualité de service", "en": "Quality of Service"},
                    "polarized": true
                }, {
                    "name": "topicBrandRelationship",
                    "labels": {"fr": "Relation à la Marque", "en": "Brand Relationship"},
                    "polarized": true
                }, {
                    "name": "topicIRecommend",
                    "labels": {"fr": "Je recommande", "en": "I Recommend"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "customeraccount",
                "labels": {"fr": "Compte client", "en": "Customer Account"},
                "children": [{
                    "name": "CreateAccount",
                    "labels": {"fr": "Créer mon compte", "en": "Create Account"},
                    "polarized": false
                }, {
                    "name": "topicAccess",
                    "labels": {"fr": "Accéder à mon compte", "en": "Acces Account"},
                    "polarized": false
                }, {
                    "name": "topicCloseAccount",
                    "labels": {"fr": "Supprimer mon compte", "en": "Close Account"},
                    "polarized": false
                }, {
                    "name": "topicRegisterLoyaltyCard",
                    "labels": {"fr": "Enregistrer ma CF", "en": "Register Loyalty Card"},
                    "polarized": false
                }, {
                    "name": "IntentToModifyDetails",
                    "labels": {"fr": "Modifier mes coordonnées", "en": "Modify details"},
                    "polarized": false
                }, {"name": "topicOptIn", "labels": {"fr": "Abonnement/News", "en": "Opt-In"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "contact",
                "labels": {"fr": "Contacter le Service Client", "en": "Contact"},
                "children": [{
                    "name": "topicContactBrand",
                    "labels": {"fr": "Joignabilité", "en": "Contact GL"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "staff",
                "labels": {"fr": "Equipe", "en": "Staff"},
                "children": [{
                    "name": "topicAmability",
                    "labels": {"fr": "Amabilité", "en": "Amability"},
                    "polarized": true
                }, {
                    "name": "topicCompetency",
                    "labels": {"fr": "Compétence", "en": "Competency"},
                    "polarized": true
                }, {
                    "name": "topicAttentiveness",
                    "labels": {"fr": "Ecoute", "en": "Attentiveness"},
                    "polarized": true
                }, {
                    "name": "topicEfficiency",
                    "labels": {"fr": "Rapidité", "en": "Efficiency"},
                    "polarized": true
                }, {
                    "name": "topicDisponibility",
                    "labels": {"fr": "Disponibilité", "en": "Disponibility"},
                    "polarized": true
                }],
                "polarized": false
            }, {
                "name": "nonactionable",
                "labels": {"fr": "Non Actionnables", "en": "Non Actionnable"},
                "children": [{
                    "name": "topicNonActionable",
                    "labels": {"fr": "Non Actionnables", "en": "Non Actionnable"},
                    "polarized": false
                }],
                "polarized": false
            }]
        },
        "enhancement.categories.emotion": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Emotions", "en": "Emotions"},
            "hierarchical": true,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 103},
                "dashboardFilterView": {"enabled": true, "order": 103},
                "feedbackDetailsView": {"enabled": true, "order": 103}
            },
            "values": [{
                "name": "satisfaction",
                "labels": {"fr": "Satisfaction", "en": "Satisfaction"},
                "children": [{
                    "name": "topicSatisfaction",
                    "labels": {"fr": "Satisfait", "en": "Satisfaction"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "anger",
                "labels": {"fr": "En colère", "en": "Anger"},
                "children": [{
                    "name": "topicAnger",
                    "labels": {"fr": "En Colère", "en": "Anger"},
                    "polarized": false
                }, {
                    "name": "topicEmbarrassment",
                    "labels": {"fr": "Embarrasé", "en": "Embarrassment"},
                    "polarized": false
                }, {"name": "topicShock", "labels": {"fr": "Choqué", "en": "Shock"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "fear",
                "labels": {"fr": "Peur", "en": "Fear"},
                "children": [{"name": "topicFear", "labels": {"fr": "Inquiet", "en": "Fear"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "sadness",
                "labels": {"fr": "Triste", "en": "Sadness"},
                "children": [{
                    "name": "topicSadness",
                    "labels": {"fr": "Triste", "en": "Sadness"},
                    "polarized": false
                }, {
                    "name": "topicDisappointment",
                    "labels": {"fr": "Déçu", "en": "Disappointment"},
                    "polarized": false
                }],
                "polarized": false
            }, {
                "name": "dissatisfaction",
                "labels": {"fr": "Insatisfait", "en": "Dissatisfaction"},
                "children": [{
                    "name": "topicDissatisfaction",
                    "labels": {"fr": "Insatisfait", "en": "Dissatisfaction"},
                    "polarized": false
                }, {"name": "topicDoubt", "labels": {"fr": "Doute", "en": "Doubt"}, "polarized": false}],
                "polarized": false
            }, {
                "name": "reaction",
                "labels": {"fr": "Réaction", "en": "Reaction"},
                "children": [{
                    "name": "topicSurprise",
                    "labels": {"fr": "Surpris", "en": "Surprise"},
                    "polarized": false
                }],
                "polarized": false
            }]
        },
        "enhancement.categories.risk": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Intentions de mes clients", "en": "Risks"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 104},
                "dashboardFilterView": {"enabled": true, "order": 104},
                "feedbackDetailsView": {"enabled": true, "order": 104}
            },
            "values": [{
                "name": "callCustomerService",
                "labels": {"fr": "Effort Client", "en": "Asking for recall"},
                "polarized": false
            }, {"name": "churn", "labels": {"fr": "Churn", "en": "Churn"}, "polarized": false}, {
                "name": "legal",
                "labels": {"fr": "Litige", "en": "Legal Risk"},
                "polarized": false
            }, {
                "name": "NotWarned",
                "labels": {"fr": "Non prévenu", "en": "Not warned"},
                "polarized": false
            }, {
                "name": "Fraud",
                "labels": {"fr": "Fraude", "en": "Fraud"},
                "polarized": false
            }, {
                "name": "riskReputation",
                "labels": {"fr": "Mauvaise Réputation", "en": "Reputation"},
                "polarized": false
            }, {
                "name": "UnkeptCommitment",
                "labels": {"fr": "Engagements non tenus", "en": "Unkept commitment"},
                "polarized": false
            }, {
                "name": "askingForRecall",
                "labels": {"fr": "Demandes de rappel", "en": "Recall"},
                "polarized": false
            }, {"name": "Harassment", "labels": {"fr": "Harcèlement", "en": "Harassment"}, "polarized": false}]
        },
        "enhancement.satisfaction": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Satisfaction Client", "en": "Sentiment"},
            "hierarchical": true,
            "exportable": true,
            "polarized": true,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 105},
                "dashboardFilterView": {"enabled": true, "order": 105},
                "feedbackDetailsView": {"enabled": false, "order": 105}
            },
            "values": [{
                "name": "negative",
                "labels": {"fr": "Négative", "en": "Negative"},
                "polarized": false
            }, {
                "name": "positive",
                "labels": {"fr": "Positive", "en": "Positive"},
                "polarized": false
            }, {"name": "mixed", "labels": {"fr": "Mitigé", "en": "Mixed"}, "polarized": false}, {
                "name": "neutral",
                "labels": {"fr": "Neutre", "en": "Neutral"},
                "polarized": false
            }]
        },
        "enhancement.categories.satisfaction": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Satisfaction Client", "en": "Sentiment"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 106},
                "dashboardFilterView": {"enabled": false, "order": 106},
                "feedbackDetailsView": {"enabled": true, "order": 106}
            },
            "values": [{
                "name": "negative",
                "labels": {"fr": "Négative", "en": "Negative"},
                "polarized": false
            }, {"name": "positive", "labels": {"fr": "Positive", "en": "Positive"}, "polarized": false}]
        },
        "enhancement.categories.tag": {
            "@version": "1",
            "enabled": false,
            "labels": {"fr": "Tags", "en": "Tags"},
            "hierarchical": true,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 105},
                "dashboardFilterView": {"enabled": true, "order": 105},
                "feedbackDetailsView": {"enabled": true, "order": 105}
            }
        },
        "enhancement.nps": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "NPS", "en": "NPS"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 108},
                "dashboardFilterView": {"enabled": true, "order": 108},
                "feedbackDetailsView": {"enabled": true, "order": 108}
            },
            "values": [{
                "name": "1",
                "labels": {"fr": "Promoteurs", "en": "Promoters"},
                "polarized": false
            }, {"name": "-1", "labels": {"fr": "Détracteurs", "en": "Detractors"}, "polarized": false}, {
                "name": "0",
                "labels": {"fr": "Passifs", "en": "Passives"},
                "polarized": false
            }]
        },
        "enhancement.computational.nps100": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "NPS", "en": "NPS"},
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.recommendationScore": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Score de recommandation", "en": "Recommendation score"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 202},
                "dashboardFilterView": {"enabled": false, "order": 202},
                "feedbackDetailsView": {"enabled": false, "order": 202}
            }
        },
        "metadata.custom.veckoFilename": {
            "@version": "1",
            "enabled": false,
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.month": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.subject": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "verbatim": {"@version": "1", "enabled": true, "hierarchical": false, "exportable": true, "polarized": false},
        "metadata.custom.place_name": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Magasin", "en": "Store"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 110},
                "dashboardFilterView": {"enabled": true, "order": 110},
                "feedbackDetailsView": {"enabled": true, "order": 110},
                "dynamicDashboardSelector": {"enabled": true, "order": 110},
                "topicsStatListView": {"enabled": true, "order": 10}
            }
        },
        "metadata.custom.place_levels_Regroupement_Bu": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Regroupement BU", "en": "BU"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 111},
                "dashboardFilterView": {"enabled": true, "order": 111},
                "feedbackDetailsView": {"enabled": true, "order": 111},
                "dynamicDashboardSelector": {"enabled": false, "order": 111}
            }
        },
        "metadata.custom.place_levels_Enseigne": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Enseigne", "en": "Company"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 111},
                "dashboardFilterView": {"enabled": true, "order": 111},
                "feedbackDetailsView": {"enabled": true, "order": 111},
                "dynamicDashboardSelector": {"enabled": false, "order": 111}
            }
        },
        "metadata.custom.place_levels_Canal": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Canal", "en": "Channel"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 111},
                "dashboardFilterView": {"enabled": true, "order": 111},
                "feedbackDetailsView": {"enabled": true, "order": 111},
                "dynamicDashboardSelector": {"enabled": false, "order": 111}
            }
        },
        "metadata.custom.context_cz_tag": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Parcours", "en": "Journey"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 112},
                "dashboardFilterView": {"enabled": true, "order": 112},
                "feedbackDetailsView": {"enabled": true, "order": 112}
            }
        },
        "metadata.custom.context_extra_order_type": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Type d'achat", "en": "Purchase Type"},
            "hierarchical": false,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 113},
                "dashboardFilterView": {"enabled": true, "order": 113},
                "feedbackDetailsView": {"enabled": true, "order": 113}
            }
        },
        "metadata.custom.context_extra_brand": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Marques", "en": "Brands"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 114},
                "dashboardFilterView": {"enabled": true, "order": 114},
                "feedbackDetailsView": {"enabled": true, "order": 114},
                "dynamicDashboardSelector": {"enabled": true, "order": 114}
            }
        },
        "metadata.custom.context_extra_fid": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Fidélité", "en": "Loyalty"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 115},
                "dashboardFilterView": {"enabled": true, "order": 115},
                "feedbackDetailsView": {"enabled": true, "order": 115}
            }
        },
        "metadata.custom.context_extra_statut_pqsta_fidgl": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Statut Fidélité", "en": "Loyalty Status"},
            "hierarchical": true,
            "exportable": true,
            "polarized": false,
            "channelKind": "survey",
            "display": {
                "feedbackFilterView": {"enabled": true, "order": 116},
                "dashboardFilterView": {"enabled": true, "order": 116},
                "feedbackDetailsView": {"enabled": true, "order": 116}
            }
        },
        "metadata.custom.conversation": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": false,
            "polarized": false
        },
        "metadata.custom.idUser": {
            "@version": "1",
            "enabled": true,
            "hierarchical": false,
            "exportable": true,
            "polarized": false
        },
        "metadata.custom.lazy": {
            "@version": "1",
            "enabled": true,
            "labels": {"fr": "Paresseux", "en": "Lazy"},
            "hierarchical": false,
            "exportable": false,
            "polarized": false,
            "display": {
                "feedbackFilterView": {"enabled": false, "order": 1},
                "dashboardFilterView": {"enabled": false, "order": 1},
                "feedbackDetailsView": {"enabled": false, "order": 1}
            },
            "values": [{
                "name": "value1",
                "labels": {"fr": "valeur 1", "en": "value 1"},
                "polarized": false
            }, {"name": "value2", "labels": {"fr": "valeur 2", "en": "value 2"}, "polarized": false}]
        }
    }, "fieldsValue": {
        "metadata.standard.channelName": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.place_name": [{"value": "BHV Marais"}, {"value": "GaleriesLafayette.com"}, {"value": "Galeries Lafayette HAUSSMANN"}, {"value": "Galeries Lafayette Maine Montparnasse"}, {"value": "BHV Parly 2"}, {"value": "Galeries Lafayette Toulouse Lapeyrouse"}, {"value": "Galeries Lafayette Nice Cap 3000"}, {"value": "Galeries Lafayette Lyon Bron"}, {"value": "Galeries Lafayette Bordeaux"}, {"value": "Galeries Lafayette Nice Massena"}, {"value": "Galeries Lafayette Strasbourg"}, {"value": "Galeries Lafayette Nantes Decre"}, {"value": "Galeries Lafayette Lyon Part Dieu"}, {"value": "Galeries Lafayette Marseille Bourse"}, {"value": "Galeries Lafayette Montpellier"}, {"value": "Galeries Lafayette Perpignan"}, {"value": "Galeries Lafayette Annecy"}, {"value": "Galeries Lafayette Avignon"}, {"value": "bhv.fr"}, {"value": "Galeries Lafayette Marseille Prado"}, {"value": "Galeries Lafayette Metz"}, {"value": "Galeries Lafayette Rennes"}, {"value": "Galeries Lafayette Rosny"}, {"value": "Galeries Lafayette Carre-Senart"}, {"value": "Galeries Lafayette Dijon"}, {"value": "Galeries Lafayette Grenoble"}, {"value": "Galeries Lafayette Orleans"}, {"value": "Galeries Lafayette Reims"}, {"value": "Galeries Lafayette Clermont Ferrand"}, {"value": "Galeries Lafayette Biarritz"}, {"value": "Galeries Lafayette Tours"}, {"value": "BHV Limonest"}, {"value": "Galeries Lafayette Caen"}, {"value": "Galeries Lafayette Bayonne"}, {"value": "Galeries Lafayette Angers"}, {"value": "Galeries Lafayette Rouen"}, {"value": "Galeries Lafayette Amiens"}, {"value": "Galeries Lafayette Besançon"}, {"value": "Galeries Lafayette Toulon"}, {"value": "Galeries Lafayette Le Mans"}, {"value": "Galeries Lafayette Limoges"}, {"value": "Galeries Lafayette La Rochelle"}, {"value": "Galeries Lafayette l'Outlet ONE NATION"}, {"value": "Galeries Lafayette Cannes"}, {"value": "Galeries Lafayette Lorient"}, {"value": "Galeries Lafayette Béziers"}, {"value": "Galeries Lafayette l'Outlet NAILLOUX"}, {"value": "Galeries Lafayette La Roche-sur-Yon"}, {"value": "Galeries Lafayette l'Outlet ROUBAIX"}, {"value": "Galeries Lafayette Beauvais"}, {"value": "Galeries Lafayette Montauban"}, {"value": "Galeries Lafayette Dax"}, {"value": "Galeries Lafayette l'Outlet THE VILLAGE"}, {"value": "Galeries Lafayette Tarbes"}, {"value": "Galeries Lafayette Belfort"}, {"value": "Galeries Lafayette Agen"}, {"value": "Galeries Lafayette Chalon-sur-Saône"}, {"value": "Galeries Lafayette l'Outlet HONFLEUR"}, {"value": "Galeries Lafayette l'Outlet LA SEGUINIERE"}, {"value": "Galeries Lafayette l'Outlet TALANGE"}, {"value": "Galeries Lafayette l'Outlet COQUELLES"}, {"value": "Galeries Lafayette Saintes"}, {"value": "Galeries Lafayette Pau"}, {"value": "BHV Part Dieu"}, {"value": "Galeries Lafayette Champs-Elysées"}, {"value": "Galeries Lafayette Chambéry"}, {"value": "Galeries Lafayette Niort"}, {"value": "Galeries Lafayette Langon"}, {"value": "Galeries Lafayette Angoulême"}, {"value": "Galeries Lafayette Libourne"}, {"value": "Galeries Lafayette Menton"}, {"value": "L'Usine Mode et Maison VELIZY"}, {"value": "Galeries Lafayette l'Outlet ROPPENHEIM"}, {"value": "Galeries Lafayette l’Outlet L’ÎLE SAINT-DENIS"}, {"value": "Eataly Paris Marais"}],
        "metadata.custom.place_levels_Regroupement_Bu": [{"value": "Réseau GL"}, {"value": "Magasins BHV"}, {"value": "GL.com"}, {"value": "Affiliés GL"}, {"value": "Haussmann"}, {"value": "Outlets"}, {"value": "bhv.fr"}, {"value": "Champs-Elysées"}],
        "metadata.custom.place_levels_Enseigne": [{"value": "Galeries Lafayette"}, {"value": "Le BHV"}, {"value": "Galeries Lafayette l'Outlet"}, {"value": "Eataly"}],
        "metadata.custom.place_levels_Canal": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_cz_tag": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_order_type": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_brand": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_fid": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}],
        "metadata.custom.context_extra_statut_pqsta_fidgl": [{"value": "value1"}, {"value": "value2"}, {"value": "value3"}]
    }
}